//
//
//
//
//
//
//
//
//
//
//
//
//
//

import breadCrumbs from '~/components/common/breadCrumbs.vue' // 面包屑
import navigationComp from '~/components/help/navigation.vue' // 左侧导航
export default {
  components: {
    'bread-crumbs': breadCrumbs,
    'navigation-comp': navigationComp
  },
  asyncData ({ route }) {
    const arr = [
      'lang-help-instructions-for-using-vps.html',
      'lang-help-vps-product-classification.html',
      'lang-help-buy-vps-server-process.html',
      'lang-help-helpWin.html',
      'lang-help-helpMac.html',
      'lang-help-mt4-account-binding-process.html',
      'lang-help-mt5-account-binding-process.html',
      'lang-help-ctrader-account-binding-process.html'
    ]
    const activeIndex = arr.findIndex(item => item == route.name)
    return {
      activeIndex
    }
  },

  data () {
    return {
      content: {
        'zh-cn': `
        <div class="title-box">常见问题处理</div>
                  <p>
                      <strong>1、常见激活失败处理</strong>
                  </p>
                  <p>
                      1.1、MT4加载失败的情况：
                  </p>
                  <p>
                      <strong>DLL未勾选</strong>
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon1.png')}"/>
                  </p>
                  <p>
                      解决方法：在交易软件上方点击工具-选项-EA交易-DLL勾选重新加载天眼盾脚本即可。
                  </p>
                  <p>
                      <strong>2、绑定其他云主机</strong>
                  </p>
                  <p>
                      显示如下，表示该账户绑定了其他云主机，需用新的实盘账号绑定，或注销之前绑定云主机。（红框内为绑定的云主机IP）
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon2.png')}"/>
                  </p>
                  <p>
                      <strong>3、交易账户为模拟账户</strong>
                  </p>
                  <p>
                      <strong>（1100010 Demo Account is not available）</strong>
                  </p>
                  <p>
                      显示如下，表示需用实盘账号绑定，模拟账户不支持绑定。
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon3.png')}"/>
                  </p>
                  <p>
                      4、<strong>交易数量过多</strong>
                  </p>
                  <p>
                      用户在账户历史中将时间范围缩小到本月或本周，再重新激活天眼盾。
                  </p>
                  <p>
                      <strong>5、未获取到用户信息</strong>
                  </p>
                  <p>
                      显示如下，表示用户信息数据未导入到软件目录下。
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon4.png')}"/>
                  </p>
                  <p>
                      解决方法：在MT4终端中，选择EA 或 日志 &nbsp;tab页，选中任意一行日志内容，右键选择
                  </p>
                  <p>
                      打开，如图：
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon5.png')}"/>
                  </p>
                  <p>
                      然后找到对应的MQL4&#92;Files目录，如：
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon6.png')}"/>
                  </p>
                  <p>
                      进入目录后，检查是否有
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon7.png')}"/>
                  </p>
                  <p>
                      这个文件。若文件存在，检查文件大小。若
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon8.png')}"/>
                  </p>
                  <p>
                      显示为0Kb，则表示异常。可手动将正常文件导入。
                  </p>
                  <p>
                      导入方式：打开天眼盾软件目录，桌面选中天眼盾软件图标，右键将该目录下的
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon9.png')}"/>
                  </p>
                  <p>
                      文件复制（覆盖）到上面的目录下即可。导入成功后，再重新加载天眼盾脚本。
                  </p>
                  <p>
                      6.<strong>注意事项</strong>
                  </p>
                  <p>
                      6.1、云主机需达成全部续费条件才可正常使用，否则会被收回。新买的云主机需7天内达成续费条件。
                  </p>
                  <p>
                      6.2、续费条件即绑定实盘账号（专属云主机至少要绑定一个专属交易商账号），并每月在云主机进行一次交易。1元云主机和45元云主机达成续费条件，才能续费，免费的专属云主机达成续费条件即会自动免费续费。
                  </p>
                  <p>
                      6.3、续费条件查询渠道
                  </p>
                  <p>
                      打开外汇天眼APP，点击“我”“我的VPS”，再点击“立即续费”查看。
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon10.png')}"/>
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon11.png')}"/>
                  </p>
                  <p>
                      <span>若续费不满足，请绑定您的MT4/MT5交易账户并且完成一笔交易</span>
                  </p>
                  <p>
                      7.<strong>多开账号</strong>
                  </p>
                  <p>
                      右键MT4或MT5，打开文件所在位置
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon12.png')}"/>
                  </p>
                  <p>
                      点击此处退回上一路径
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon13.png')}"/>
                  </p>
                  <p>
                      复制MT4或MT5整个文件夹至桌面
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon14.png')}"/>
                  </p>
                  <p>
                      在桌面打开文件
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon15.png')}"/>
                  </p>
                  <p>
                      打开复制的MT4文件夹，创建应用程序快捷方式，发送至桌面。
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon16.png')}"/>
                  </p>
                  <p>
                      在桌面通过快捷方式即可打开新的交易软件，登录另一账户，实现多开。
                  </p>
                  <p>
                      8.<strong>天眼盾软件说明</strong>
                  </p>
                  <p>
                      天眼盾简介：
                  </p>
                  <p>
                      全球首创，唯一一款可以实时监控外汇交易账户信息，让隐藏成本无处遁形的高科技软件产品。
                  </p>
                  <p>
                      8.1、实现VPS和APP互联，可通过APP实时查看交易信息
                  </p>
                  <p>
                      8.2、实时监控账户信息，为您的交易安全保驾护航
                  </p>
                  <p>
                      8.3、通过大数据挖掘和神经网络技术实时检测隐藏交易成本，诊断交易环境
                  </p>
                  <p>
                      天眼盾软件随机启动，并自动登录。登录成功后在VPS内右下角系统托盘内可看到。
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon17.png')}"/>
                  </p>
                  <p>
                      天眼盾软件桌面图标：
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon18.png')}"/>
                  </p>
                  <p>
                      天眼盾软件界面：
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon19.png')}"/>
                  </p>
                  <p>
                      天眼盾显示的交易商列表中，若状态为”running”，表示该账户的天眼盾脚本已正常加载。 若状态为”stopped”，表示该账户的Wikifxdefense天眼盾脚本目前未加载，需及时检查并正确加载。
                  </p>
                  <p>
                      目前cTrader账号不会出现在列表中。
                  </p>
                  <p>
                      <strong>若天眼盾加载成功，APP显示正常而界面显示停止，不影响正常使用，最终以APP端显示为准。</strong>
                  </p>`,
        zh: `
        <div class="title-box">常見問題處理</div>
                  <p class="bold">
                      1.常見啟動失敗處理
                  </p>
                  <p>
                      1.1、MT4載入失敗的情況：
                  </p>
                  <p>
                      DLL未勾選
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon1.png')}"/>
                  </p>
                  <p>
                      解決方法：在交易軟體上方點選工具-選項-EA交易-DLL勾選重新載入天眼盾腳本即可。
                  </p>
                  <p class="bold">
                      2、綁定其他雲端主機
                  </p>
                  <p>
                      顯示如下，表示該帳號綁定了其他雲端主機，需用新的實盤帳號綁定，或登出之前綁定雲端主機。 （紅框內為綁定的雲端主機IP）
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon2.png')}"/>
                  </p>
                  <p class="bold">
                      3.交易帳戶為模擬帳戶
                  </p>
                  <p>
                      （1100010 Demo Account is not available）
                  </p>
                  <p>
                      顯示如下，表示需用實盤帳號綁定，模擬帳號不支援綁定。
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon3.png')}"/>
                  </p>
                  <p class="bold">
                      4.交易數量過多
                  </p>
                  <p>
                      用戶在帳戶歷史中將時間範圍縮小到本月或本週，再重新啟動天眼盾。
                  </p>
                  <p class="bold">
                      5.未獲取到用戶訊息
                  </p>
                  <p>
                      顯示如下，表示使用者資訊資料未匯入軟體目錄下。
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon4.png')}"/>
                  </p>
                  <p>
                      解決方法：在MT4終端機中，選擇EA 或 日誌 tab頁，選取任何一行日誌內容，以滑鼠右鍵選擇
                  </p>
                  <p>
                      打開，如圖：
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon5.png')}"/>
                  </p>
                  <p>
                      然後找到對應的MQL4&#92;Files目錄，如：
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon6.png')}"/>
                  </p>
                  <p>
                      進入目錄後，檢查是否有
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon7.png')}"/>
                  </p>
                  <p>
                      這個文件。 若文件存在，檢查文件大小。 若
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon8.png')}"/>
                  </p>
                  <p>
                      顯示為0Kb，則表示異常。 可手動將正常文件導入。
                  </p>
                  <p>
                      導入方式：開啟天眼盾軟體目錄，桌面選取天眼盾軟體圖標，右鍵將該目錄下的
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon9.png')}"/>
                  </p>
                  <p>
                      文件複製（覆蓋）到上面的目錄下即可。 導入成功後，再重新載入天眼盾腳本。
                  </p>
                  <p class="bold">
                      6.注意事項
                  </p>
                  <p>
                      6.1、雲端主機需達成全部續費條件才可正常使用，否則會被收回。 新買的雲端主機需7天內達成續費條件。
                  </p>
                  <p>
                      6.2.續費條件即綁定實盤帳號（專屬雲端主機至少要綁定一個專屬交易商帳號），並每月在雲端主機進行一次交易。 1元雲端主機和45元雲端主機達成續費條件，才能續費，免費的專屬雲端主機達成續費條件即會自動免費續費。
                  </p>
                  <p>
                      6.3、續費條件查詢管道
                  </p>
                  <p>
                      打開外匯天眼APP，點選“我”“我的VPS”，再點擊“立即續費”查看。
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon10.png')}"/>
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon11.png')}"/>
                  </p>
                  <p>
                      <span>若續費不滿足，請綁定您的MT4/MT5交易帳戶並且完成一筆交易</span>
                  </p>
                  <p class="bold">
                      7.多開帳號
                  </p>
                  <p>
                      右鍵MT4或MT5，開啟檔案所在位置
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon12.png')}"/>
                  </p>
                  <p>
                      點擊此處退回上一路徑
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon13.png')}"/>
                  </p>
                  <p>
                      複製MT4或MT5整個資料夾至桌面
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon14.png')}"/>
                  </p>
                  <p>
                      在桌面開啟文件
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon15.png')}"/>
                  </p>
                  <p>
                      開啟複製的MT4資料夾，建立應用程式捷徑，傳送至桌面。
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon16.png')}"/>
                  </p>
                  <p>
                      在桌面透過捷徑即可開啟新的交易軟體，登入另一個帳戶，實現多開。
                  </p>
                  <p class="bold">
                      8.天眼盾軟體說明
                  </p>
                  <p>
                      天眼盾簡介：
                  </p>
                  <p>
                      全球首創，唯一一款可以即時監控外匯交易帳戶訊息，讓隱藏成本無處遁形的高科技軟體產品。
                  </p>
                  <p>
                      8.1、實現VPS和APP互聯，可透過APP即時查看交易資訊
                  </p>
                  <p>
                      8.2、即時監控帳戶訊息，為您的交易安全保駕護航
                  </p>
                  <p>
                      8.3、透過大數據挖掘和神經網路技術即時檢測隱藏交易成本，診斷交易環境
                  </p>
                  <p>
                      天眼盾軟體隨機啟動，並自動登入.登入成功後在VPS內右下角系統托盤內可看到。
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon17.png')}"/>
                  </p>
                  <p>
                      天眼盾軟體桌面圖示：
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon18.png')}"/>
                  </p>
                  <p>
                      天眼盾軟體介面：
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon19.png')}"/>
                  </p>
                  <p>
                      天眼盾顯示的交易商列表中，若狀態為”running”，表示該帳戶的天眼盾腳本已正常加載。 若狀態為”stopped”，表示該帳戶的Wikifxdefense天眼盾腳本目前未加載，需及時檢查並 正確加載。
                  </p>
                  <p>
                      目前cTrader帳號不會出現在清單中。
                  </p>
                  <p>
                      若天眼盾載入成功，APP顯示正常而介面顯示停止，不影響正常使用，最終以APP端顯示為準。
                  </p>`,
        en: `
        <div class="title-box">Frequently Asked Questions</div>
                  <p class="bold">
                      1.Handling common activation failures
                  </p>
                  <p>
                      1.1. MT4 loading failure:
                  </p>
                  <p>
                      DLL is not checked
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon1.png')}"/>
                  </p>
                  <p>
                      Solution: Click Tools-Options-EA Trading-DLL above the trading software and check to reload the Sky Eye Shield script.
                  </p>
                  <p class="bold">
                      2.Bind other cloud hosts
                  </p>
                  <p>
                      As shown below, it means that the account is bound to other cloud hosts and needs to be bound with a new real account or bound to the cloud host before logging out. (The bound cloud host IP is in the red box)
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon2.png')}"/>
                  </p>
                  <p class="bold">
                      3.The trading account is a demo account
                  </p>
                  <p>
                      (1100010 Demo Account is not available)
                  </p>
                  <p>
                      As shown below, it means that binding with real account is required, and demo account does not support binding.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon3.png')}"/>
                  </p>
                  <p class="bold">
                      4.Too many transactions
                  </p>
                  <p>
                      The user narrows the time range in the account history to this month or this week, and then reactivates the Sky Eye Shield.
                  </p>
                  <p class="bold">
                      5.User information not obtained
                  </p>
                  <p>
                      The following is displayed, indicating that the user information data has not been imported into the software directory.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon4.png')}"/>
                  </p>
                  <p>
                      Solution: In the MT4 terminal, select the EA or Log tab page, select any line of log content, and right-click to select
                  </p>
                  <p>
                      Open, as shown in the figure:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon5.png')}"/>
                  </p>
                  <p>
                      Then find the corresponding MQL4&#92;Files directory, such as:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon6.png')}"/>
                  </p>
                  <p>
                      After entering the directory, check whether there is
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon7.png')}"/>
                  </p>
                  <p>
                      this file. If the file exists, check the file size. like
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon8.png')}"/>
                  </p>
                  <p>
                      If it displays 0Kb, it indicates an exception. Normal files can be imported manually.
                  </p>
                  <p>
                      Import method: Open the Sky Eye Shield software directory, select the Sky Eye Shield software icon on the desktop, right-click and select the
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon9.png')}"/>
                  </p>
                  <p>
                      Just copy (overwrite) the file to the directory above. After the import is successful, reload the Sky Eye Shield script.
                  </p>
                  <p>
                      6.Precautions
                  </p>
                  <p>
                      6.1. The cloud host must meet all renewal conditions before it can be used normally, otherwise it will be withdrawn. Newly purchased cloud hosts must meet renewal conditions within 7 days.
                  </p>
                  <p>
                      6.2. The renewal conditions are to bind a real trading account (the exclusive cloud host must be bound to at least one exclusive trader account) and conduct a transaction on the cloud host once a month. The 1-yuan cloud host and the 45-yuan cloud host can be renewed only if the renewal conditions are met. The free exclusive cloud host will be automatically renewed for free when the renewal conditions are met.
                  </p>
                  <p>
                      6.3. Inquiry channels for renewal conditions
                  </p>
                  <p>
                      Open the Forex Sky Eye APP, click &quot;Me&quot;, &quot;My VPS&quot;, and then click &quot;Renew Now&quot; to view.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon10.png')}"/>
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon11.png')}"/>
                  </p>
                  <p>
                      <span>If the renewal fee is not satisfied, please bind your MT4/MT5 trading account and complete a transaction</span>
                  </p>
                  <p>
                      7.Open more accounts
                  </p>
                  <p>
                      Right click on MT4 or MT5 and open the file location
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon12.png')}"/>
                  </p>
                  <p>
                      Click here to return to the previous path
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon13.png')}"/>
                  </p>
                  <p>
                      Copy the entire MT4 or MT5 folder to the desktop
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon14.png')}"/>
                  </p>
                  <p>
                      Open file on desktop
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon15.png')}"/>
                  </p>
                  <p>
                      Open the copied MT4 folder, create an application shortcut, and send it to the desktop.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon16.png')}"/>
                  </p>
                  <p>
                      You can open new trading software through a shortcut on the desktop, log in to another account, and open multiple accounts.
                  </p>
                  <p class="bold">
                      8.Sky Eye Shield Software Instructions
                  </p>
                  <p>
                      Introduction to the Sky Eye Shield:
                  </p>
                  <p>
                      The world&#39;s first and only high-tech software product that can monitor foreign exchange trading account information in real time, making hidden costs nowhere to hide.
                  </p>
                  <p>
                      8.1. Realize the interconnection between VPS and APP, and you can view transaction information in real time through the APP.
                  </p>
                  <p>
                      8.2. Monitor account information in real time to ensure the safety of your transactions.
                  </p>
                  <p>
                      8.3. Use big data mining and neural network technology to detect hidden transaction costs and diagnose the trading environment in real time
                  </p>
                  <p>
                      The Sky Eye Shield software starts randomly and logs in automatically. After successful login, it can be seen in the system tray in the lower right corner of the VPS.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon17.png')}"/>
                  </p>
                  <p>
                      Sky Eye Shield software desktop icon:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon18.png')}"/>
                  </p>
                  <p>
                      Sky Eye Shield software interface:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon19.png')}"/>
                  </p>
                  <p>
                      In the list of traders displayed by Tianyan Shield, if the status is &quot;running&quot;, it means that the account&#39;s Tianyan Shield script has been loaded normally. If the status is &quot;stopped&quot;, it means that the account&#39;s Wikifxdefense Tianyan Shield script is not currently loaded and needs to be checked in time and Loaded correctly.
                  </p>
                  <p>
                      Currently cTrader accounts will not appear in the list.
                  </p>
                  <p>
                      If the Sky Eye Shield is loaded successfully, the APP displays normally but the interface display stops, which does not affect normal use. The final display shall be subject to the APP display.
                  </p>`,
        ru: `
        <div class="title-box">Часто задаваемые вопросы</div>
                  <p class="bold">
                      1.Обработка распространенных сбоев активации
                  </p>
                  <p>
                      1.1. Сбой загрузки МТ4:
                  </p>
                  <p>
                      DLL не проверяется
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon1.png')}"/>
                  </p>
                  <p>
                      Решение: нажмите «Инструменты-Параметры-EA Trading-DLL» над торговым программным обеспечением и установите флажок, чтобы перезагрузить сценарий Sky Eye Shield.
                  </p>
                  <p class="bold">
                      2.Привяжите другие облачные хосты
                  </p>
                  <p>
                      Как показано ниже, это означает, что учетная запись привязана к другим облачным хостам и ее необходимо привязать к новой реальной учетной записи или привязать к облачному хосту перед выходом из системы. (IP-адрес привязанного облачного хоста указан в красном поле)
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon2.png')}"/>
                  </p>
                  <p class="bold">
                      3.Торговый счет является демо-счетом.
                  </p>
                  <p>
                      (Демо-счет 1100010 недоступен)
                  </p>
                  <p>
                      Как показано ниже, это означает, что требуется привязка к реальной учетной записи, а демо-счет не поддерживает привязку.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon3.png')}"/>
                  </p>
                  <p class="bold">
                      4.Слишком много транзакций
                  </p>
                  <p>
                      Пользователь сужает временной диапазон в истории аккаунта до этого месяца или этой недели, а затем повторно активирует Sky Eye Shield.
                  </p>
                  <p class="bold">
                      5.Информация о пользователе не получена
                  </p>
                  <p>
                      Отображается следующее, указывающее, что данные пользовательской информации не были импортированы в каталог программного обеспечения.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon4.png')}"/>
                  </p>
                  <p>
                      Решение. В терминале MT4 выберите вкладку «Советник» или «Журнал», выберите любую строку содержимого журнала и щелкните правой кнопкой мыши, чтобы выбрать
                  </p>
                  <p>
                      Откройте, как показано на рисунке:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon5.png')}"/>
                  </p>
                  <p>
                      Затем найдите соответствующий каталог MQL4&#92;Files, например:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon6.png')}"/>
                  </p>
                  <p>
                      После входа в каталог проверьте, есть ли
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon7.png')}"/>
                  </p>
                  <p>
                      этот файл. Если файл существует, проверьте его размер. нравиться
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon8.png')}"/>
                  </p>
                  <p>
                      Если отображается 0 КБ, это указывает на исключение. Обычные файлы можно импортировать вручную.
                  </p>
                  <p>
                      Метод импорта: откройте каталог программного обеспечения Sky Eye Shield, выберите значок программного обеспечения Sky Eye Shield на рабочем столе, щелкните правой кнопкой мыши и выберите значок.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon9.png')}"/>
                  </p>
                  <p>
                      Просто скопируйте (перезапишите) файл в каталог выше. После успешного импорта перезагрузите скрипт Sky Eye Shield.
                  </p>
                  <p class="bold">
                      6.Меры предосторожности
                  </p>
                  <p>
                      6.1 Облачный хост должен соответствовать всем условиям продления, прежде чем его можно будет использовать в обычном режиме, в противном случае он будет отозван. Недавно приобретенные облачные хосты должны соответствовать условиям продления в течение 7 дней.
                  </p>
                  <p>
                      6.2 Условия продления заключаются в привязке реального торгового счета (эксклюзивный облачный хост должен быть привязан как минимум к одному эксклюзивному аккаунту трейдера) и проведении транзакции на облачном хосте один раз в месяц. Облачный хост за 1 юань и облачный хост за 45 юаней можно продлить только при выполнении условий продления. Бесплатный эксклюзивный облачный хост будет автоматически продлен бесплатно при выполнении условий продления.
                  </p>
                  <p>
                      6.3 Каналы запроса условий продления.
                  </p>
                  <p>
                      Откройте приложение Forex Sky Eye, нажмите «Я», «Мой VPS», а затем нажмите «Обновить сейчас», чтобы просмотреть.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon10.png')}"/>
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon11.png')}"/>
                  </p>
                  <p>
                      <span>Если плата за продление не удовлетворена, привяжите свой торговый счет MT4/MT5 и завершите транзакцию.</span>
                  </p>
                  <p class="bold">
                      7.Откройте больше счетов
                  </p>
                  <p>
                      Щелкните правой кнопкой мыши MT4 или MT5 и откройте местоположение файла.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon12.png')}"/>
                  </p>
                  <p>
                      Нажмите здесь, чтобы вернуться к предыдущему пути
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon13.png')}"/>
                  </p>
                  <p>
                      Скопируйте всю папку MT4 или MT5 на рабочий стол.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon14.png')}"/>
                  </p>
                  <p>
                      Открыть файл на рабочем столе
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon15.png')}"/>
                  </p>
                  <p>
                      Откройте скопированную папку MT4, создайте ярлык приложения и отправьте его на рабочий стол.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon16.png')}"/>
                  </p>
                  <p>
                      Вы можете открыть новое торговое программное обеспечение с помощью ярлыка на рабочем столе, войти в другую учетную запись и открыть несколько учетных записей.
                  </p>
                  <p class="bold">
                      8.Инструкции по программному обеспечению Sky Eye Shield
                  </p>
                  <p>
                      Знакомство с небесным глазным щитом:
                  </p>
                  <p>
                      Первый и единственный в мире высокотехнологичный программный продукт, который может отслеживать информацию о торговых счетах на иностранной валюте в режиме реального времени, что позволяет не скрывать скрытые расходы.
                  </p>
                  <p>
                      8.1. Реализуйте взаимосвязь между VPS и приложением, и вы сможете просматривать информацию о транзакциях в режиме реального времени через приложение.
                  </p>
                  <p>
                      8.2. Отслеживайте информацию об учетной записи в режиме реального времени, чтобы обеспечить безопасность ваших транзакций.
                  </p>
                  <p>
                      8.3. Используйте технологию анализа больших данных и нейронных сетей для обнаружения скрытых транзакционных издержек и диагностики торговой среды в режиме реального времени.
                  </p>
                  <p>
                      Программное обеспечение Sky Eye Shield запускается случайным образом и автоматически входит в систему. После успешного входа в систему его можно увидеть на панели задач в правом нижнем углу VPS.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon17.png')}"/>
                  </p>
                  <p>
                      Значок программы Sky Eye Shield на рабочем столе:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon18.png')}"/>
                  </p>
                  <p>
                      Программный интерфейс Sky Eye Shield:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon19.png')}"/>
                  </p>
                  <p>
                      В списке трейдеров, отображаемых Tianyan Shield, статус «работает» означает, что скрипт Tianyan Shield учетной записи загружен нормально. Если статус «остановлен», это означает, что скрипт Wikifxdefense Tianyan Shield учетной записи не загружен. в данный момент загружен, и его необходимо вовремя проверить и загрузить правильно.
                  </p>
                  <p>
                      В настоящее время счета cTrader не отображаются в списке.
                  </p>
                  <p>
                      Если Sky Eye Shield успешно загружен, приложение отображается нормально, но отображение интерфейса останавливается, что не влияет на нормальное использование. Окончательное отображение должно зависеть от отображения приложения.
                  </p>`,
        ja: `
        <div class="title-box">よくある質問</div>
                  <p class="bold">
                      1.一般的なアクティベーション失敗の処理
                  </p>
                  <p>
                      1.1. MT4の読み込み失敗:
                  </p>
                  <p>
                      DLLはチェックされていません
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon1.png')}"/>
                  </p>
                  <p>
                      解決策: 取引ソフトウェアの上にある [ツール]-[オプション]-[EA Trading-DLL] をクリックし、Sky Eye Shield スクリプトを再ロードすることを確認します。
                  </p>
                          <p class="bold">
                              2.他のクラウドホストをバインドする
                          </p>
                  <p>
                      以下に示すように、これはアカウントが他のクラウド ホストにバインドされており、ログアウトする前に新しい実際のアカウントにバインドするか、クラウド ホストにバインドする必要があることを意味します。 (バインドされたクラウド ホスト IP は赤いボックス内にあります)
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon2.png')}"/>
                  </p>
                  <p class="bold">
                      3.取引口座はデモ口座です
                  </p>
                  <p>
                      (1100010 デモ口座は利用できません)
                  </p>
                  <p>
                      以下に示すように、これはリアルアカウントとのバインドが必要であることを意味し、デモアカウントはバインドをサポートしていません。
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon3.png')}"/>
                  </p>
                  <p class="bold">
                      4.トランザクションが多すぎる
                  </p>
                  <p>
                      ユーザーは、アカウント履歴の期間を今月または今週に絞り込み、スカイ アイ シールドを再アクティブ化します。
                  </p>
                  <p class="bold">
                      5.ユーザー情報が取得できない
                  </p>
                  <p>
                      以下のように、ユーザー情報データがソフトウェアディレクトリにインポートされていないことを意味します。
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon4.png')}"/>
                  </p>
                  <p>
                      解決策: MT4 ターミナルで、EA またはログ タブ ページを選択し、ログ コンテンツの任意の行を選択し、右クリックして選択します。
                  </p>
                  <p>
                      図に示すように、開きます。
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon5.png')}"/>
                  </p>
                  <p>
                      次に、次のような対応する MQL4&#92;Files ディレクトリを見つけます。
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon6.png')}"/>
                  </p>
                  <p>
                      ディレクトリに入ったら、
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon7.png')}"/>
                  </p>
                  <p>
                      このファイル。 ファイルが存在する場合は、ファイルサイズを確認してください。 のように
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon8.png')}"/>
                  </p>
                  <p>
                      0Kb と表示される場合は、例外を示します。 通常のファイルは手動でインポートできます。
                  </p>
                  <p>
                      インポート方法: Sky Eye Shield ソフトウェア ディレクトリを開き、デスクトップ上の Sky Eye Shield ソフトウェア アイコンを選択し、右クリックして
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon9.png')}"/>
                  </p>
                  <p>
                      ファイルを上記のディレクトリにコピー（上書き）するだけです。 インポートが成功したら、Sky Eye Shield スクリプトをリロードします。
                  </p>
                  <p class="bold">
                      6.注意事項
                  </p>
                  <p>
                      6.1. クラウド ホストは、通常に使用する前にすべての更新条件を満たしている必要があります。満たさない場合、そのホストは取り消されます。 新しく購入したクラウド ホストは、7 日以内に更新条件を満たす必要があります。
                  </p>
                  <p>
                      6.2. 更新条件は、実際の取引口座をバインドし（専用クラウド ホストは少なくとも 1 つの専用トレーダー アカウントにバインドする必要があります）、月に 1 回クラウド ホスト上で取引を実行することです。 1元クラウドホストと45元クラウドホストは更新条件を満たした場合のみ更新可能、無料専用クラウドホストは更新条件を満たした場合のみ無料で自動更新されます。
                  </p>
                  <p>
                      6.3. 更新条件に関する問い合わせ窓口
                  </p>
                  <p>
                      Forex Sky Eye APPを開き、「私」、「私のVPS」をクリックし、「今すぐ更新」をクリックして表示します。
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon10.png')}"/>
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon11.png')}"/>
                  </p>
                  <p>
                      <span>更新料が満たされない場合は、MT4/MT5 取引口座をバインドして取引を完了してください。</span>
                  </p>
                  <p class="bold">
                      7.さらに口座を開設する
                  </p>
                  <p>
                      MT4またはMT5を右クリックしてファイルの場所を開きます
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon12.png')}"/>
                  </p>
                  <p>
                      前のパスに戻るにはここをクリックしてください
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon13.png')}"/>
                  </p>
                  <p>
                      MT4 または MT5 フォルダー全体をデスクトップにコピーします。
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon14.png')}"/>
                  </p>
                  <p>
                      デスクトップ上のファイルを開く
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon15.png')}"/>
                  </p>
                  <p>
                      コピーしたMT4フォルダーを開き、アプリケーションのショートカットを作成し、デスクトップに送信します。
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon16.png')}"/>
                  </p>
                  <p>
                      デスクトップ上のショートカットから新しい取引ソフトウェアを開いたり、別の口座にログインしたり、複数の口座を開設したりできます。
                  </p>
                  <p class="bold">
                      8.Sky Eye Shield ソフトウェアの説明書
                  </p>
                  <p>
                      スカイ アイ シールドの紹介:
                  </p>
                  <p>
                      外国為替取引口座情報をリアルタイムで監視できる世界初かつ唯一のハイテク ソフトウェア製品で、隠れたコストをどこにも隠すことができません。
                  </p>
                  <p>
                      8.1. VPS と APP 間の相互接続を実現し、APP を通じてトランザクション情報をリアルタイムに表示できます。
                  </p>
                  <p>
                      8.2. 取引の安全性を確保するために、アカウント情報をリアルタイムで監視します。
                  </p>
                  <p>
                      8.3. ビッグデータマイニングとニューラルネットワークテクノロジーを使用して、隠れた取引コストを検出し、取引環境をリアルタイムで診断します。
                  </p>
                  <p>
                      Sky Eye Shield ソフトウェアはランダムに起動し、ログインに成功すると、VPS の右下隅のシステム トレイに表示されます。
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon17.png')}"/>
                  </p>
                  <p>
                      Sky Eye Shield ソフトウェアのデスクトップ アイコン:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon18.png')}"/>
                  </p>
                  <p>
                      スカイ アイ シールド ソフトウェア インターフェイス:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon19.png')}"/>
                  </p>
                  <p>
                      Tianyan Shield によって表示されるトレーダーのリストで、ステータスが「実行中」の場合、アカウントの Tianyan Shield スクリプトが正常にロードされていることを意味します。ステータスが「停止」の場合、アカウントの Wikifxdefense Tianyan Shield スクリプトがロードされていないことを意味します。現在ロードされており、時間内にチェックして正しくロードする必要があります。
                  </p>
                  <p>
                      現在、cTrader アカウントはリストに表示されません。
                  </p>
                  <p>
                      Sky Eye Shield が正常にロードされると、APP は正常に表示されますが、インターフェイスの表示は停止しますが、最終的な表示は APP の表示に従います。
                  </p>`,
        th: `
        <div class="title-box">คำถามที่พบบ่อย</div>
                          <p class="bold">
                              1.การจัดการความล้มเหลวในการเปิดใช้งานทั่วไป
                          </p>
                  <p>
                      1.1. การโหลด MT4 ล้มเหลว:
                  </p>
                  <p>
                      DLL ไม่ได้ถูกตรวจสอบ
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon1.png')}"/>
                  </p>
                  <p>
                      วิธีแก้ไข: คลิก Tools-Options-EA Trading-DLL เหนือซอฟต์แวร์การซื้อขาย และเลือกเพื่อโหลดสคริปต์ Sky Eye Shield อีกครั้ง
                  </p>
                          <p class="bold">
                              2.เชื่อมโยงโฮสต์คลาวด์อื่น ๆ
                          </p>
                  <p>
                      ดังที่แสดงด้านล่าง หมายความว่าบัญชีเชื่อมโยงกับโฮสต์คลาวด์อื่น และจำเป็นต้องผูกกับบัญชีจริงใหม่หรือเชื่อมโยงกับโฮสต์คลาวด์ก่อนที่จะออกจากระบบ (IP โฮสต์คลาวด์ที่ถูกผูกไว้อยู่ในกล่องสีแดง)
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon2.png')}"/>
                  </p>
                          <p class="bold">
                              3.บัญชีซื้อขายเป็นบัญชีทดลอง
                          </p>
                  <p>
                      (บัญชีทดลอง 1100010 ไม่สามารถใช้งานได้)
                  </p>
                  <p>
                      ดังที่แสดงด้านล่าง หมายความว่าจำเป็นต้องมีการเชื่อมโยงกับบัญชีจริง และบัญชีทดลองไม่รองรับการเชื่อมโยง
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon3.png')}"/>
                  </p>
                          <p class="bold">
                              4.มีการทำธุรกรรมมากเกินไป
                          </p>
                  <p>
                      ผู้ใช้จะจำกัดช่วงเวลาในประวัติบัญชีให้แคบลงเหลือเดือนนี้หรือสัปดาห์นี้ จากนั้นเปิดใช้งาน Sky Eye Shield อีกครั้ง
                  </p>
                          <p class="bold">
                              5.ไม่ได้รับข้อมูลผู้ใช้
                          </p>
                  <p>
                      ดังที่แสดงด้านล่าง หมายความว่าข้อมูลข้อมูลผู้ใช้ไม่ได้ถูกนำเข้าไปยังไดเร็กทอรีซอฟต์แวร์
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon4.png')}"/>
                  </p>
                  <p>
                      วิธีแก้ไข: ในเทอร์มินัล MT4 ให้เลือกหน้าแท็บ EA หรือ Log เลือกบรรทัดเนื้อหาบันทึกใดก็ได้ และคลิกขวาเพื่อเลือก
                  </p>
                  <p>
                      เปิดดังแสดงในรูป:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon5.png')}"/>
                  </p>
                  <p>
                      จากนั้นค้นหาไดเร็กทอรี MQL4&#92;Files ที่เกี่ยวข้อง เช่น:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon6.png')}"/>
                  </p>
                  <p>
                      หลังจากเข้าสู่ไดเร็กทอรีแล้วให้ตรวจสอบว่ามีหรือไม่
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon7.png')}"/>
                  </p>
                  <p>
                      ไฟล์นี้ หากมีไฟล์อยู่ ให้ตรวจสอบขนาดไฟล์ ชอบ
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon8.png')}"/>
                  </p>
                  <p>
                      หากแสดงเป็น 0Kb แสดงว่ามีข้อยกเว้น ไฟล์ปกติสามารถนำเข้าได้ด้วยตนเอง
                  </p>
                  <p>
                      วิธีการนำเข้า: เปิดไดเร็กทอรีซอฟต์แวร์ Sky Eye Shield เลือกไอคอนซอฟต์แวร์ Sky Eye Shield บนเดสก์ท็อป คลิกขวาและเลือก
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon9.png')}"/>
                  </p>
                  <p>
                      เพียงคัดลอก (เขียนทับ) ไฟล์ไปยังไดเร็กทอรีด้านบน หลังจากการนำเข้าสำเร็จ ให้โหลดสคริปต์ Sky Eye Shield อีกครั้ง
                  </p>
                          <p class="bold">
                              6.ข้อควรระวัง
                          </p>
                  <p>
                      6.1. โฮสต์คลาวด์จะต้องตรงตามเงื่อนไขการต่ออายุทั้งหมดก่อนจึงจะสามารถใช้งานได้ตามปกติ มิฉะนั้นจะถูกเพิกถอน โฮสต์คลาวด์ที่เพิ่งซื้อใหม่จะต้องตรงตามเงื่อนไขการต่ออายุภายใน 7 วัน
                  </p>
                  <p>
                      6.2. เงื่อนไขการต่ออายุคือการผูกบัญชีซื้อขายจริง (โฮสต์คลาวด์พิเศษจะต้องผูกกับบัญชีเทรดเดอร์พิเศษอย่างน้อยหนึ่งบัญชี) และทำธุรกรรมบนโฮสต์คลาวด์เดือนละครั้ง สามารถต่ออายุคลาวด์โฮสต์ราคา 1 หยวนและคลาวด์โฮสต์ราคา 45 หยวนได้ก็ต่อเมื่อตรงตามเงื่อนไขการต่ออายุเท่านั้น คลาวด์โฮสต์พิเศษแบบฟรีจะต่ออายุฟรีโดยอัตโนมัติเมื่อตรงตามเงื่อนไขการต่ออายุ
                  </p>
                  <p>
                      6.3. ช่องทางสอบถามเงื่อนไขการต่ออายุ
                  </p>
                  <p>
                      เปิดแอป Forex Sky Eye คลิก &quot;ฉัน&quot; &quot;VPS ของฉัน&quot; จากนั้นคลิก &quot;ต่ออายุทันที&quot; เพื่อดู
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon10.png')}"/>
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon11.png')}"/>
                  </p>
                  <p>
                      <span>หากค่าธรรมเนียมการต่ออายุไม่เป็นที่พอใจ โปรดผูกบัญชีซื้อขาย MT4/MT5 ของคุณและทำธุรกรรมให้เสร็จสิ้น</span>
                  </p>
                          <p class="bold">
                              7.เปิดบัญชีเพิ่มเติม
                          </p>
                  <p>
                      คลิกขวาที่ MT4 หรือ MT5 แล้วเปิดตำแหน่งไฟล์
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon12.png')}"/>
                  </p>
                  <p>
                      คลิกที่นี่เพื่อกลับไปยังเส้นทางก่อนหน้า
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon13.png')}"/>
                  </p>
                  <p>
                      คัดลอกโฟลเดอร์ MT4 หรือ MT5 ทั้งหมดไปยังเดสก์ท็อป
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon14.png')}"/>
                  </p>
                  <p>
                      เปิดไฟล์บนเดสก์ท็อป
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon15.png')}"/>
                  </p>
                  <p>
                      เปิดโฟลเดอร์ MT4 ที่คัดลอก สร้างทางลัดไปยังแอปพลิเคชัน และส่งไปที่เดสก์ท็อป
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon16.png')}"/>
                  </p>
                  <p>
                      คุณสามารถเปิดซอฟต์แวร์การซื้อขายใหม่ผ่านทางลัดบนเดสก์ท็อป เข้าสู่ระบบบัญชีอื่น และเปิดหลายบัญชีได้
                  </p>
                          <p class="bold">
                              8.คำแนะนำซอฟต์แวร์ Sky Eye Shield
                          </p>
                  <p>
                      ข้อมูลเบื้องต้นเกี่ยวกับ Sky Eye Shield:
                  </p>
                  <p>
                      ผลิตภัณฑ์ซอฟต์แวร์ไฮเทคตัวแรกและตัวเดียวของโลกที่สามารถตรวจสอบข้อมูลบัญชีซื้อขายแลกเปลี่ยนเงินตราต่างประเทศแบบเรียลไทม์ ทำให้ต้นทุนที่ซ่อนอยู่ไม่มีที่ซ่อน
                  </p>
                  <p>
                      8.1. ตระหนักถึงการเชื่อมต่อระหว่าง VPS และ APP และคุณสามารถดูข้อมูลการทำธุรกรรมแบบเรียลไทม์ผ่าน APP
                  </p>
                  <p>
                      8.2. ตรวจสอบข้อมูลบัญชีแบบเรียลไทม์เพื่อความปลอดภัยของธุรกรรมของคุณ
                  </p>
                  <p>
                      8.3. ใช้การขุดข้อมูลขนาดใหญ่และเทคโนโลยีโครงข่ายประสาทเทียมเพื่อตรวจจับต้นทุนการทำธุรกรรมที่ซ่อนอยู่และวิเคราะห์สภาพแวดล้อมการซื้อขายแบบเรียลไทม์
                  </p>
                  <p>
                      ซอฟต์แวร์ Sky Eye Shield เริ่มต้นแบบสุ่มและเข้าสู่ระบบโดยอัตโนมัติ หลังจากเข้าสู่ระบบสำเร็จ สามารถดูได้ในถาดระบบที่มุมขวาล่างของ VPS
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon17.png')}"/>
                  </p>
                  <p>
                      ไอคอนเดสก์ท็อปซอฟต์แวร์ Sky Eye Shield:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon18.png')}"/>
                  </p>
                  <p>
                      อินเทอร์เฟซซอฟต์แวร์ Sky Eye Shield:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon19.png')}"/>
                  </p>
                  <p>
                      ในรายชื่อเทรดเดอร์ที่แสดงโดย Tianyan Shield หากสถานะเป็น &quot;กำลังทำงาน&quot; แสดงว่าสคริปต์ Tianyan Shield ของบัญชีถูกโหลดตามปกติ หากสถานะเป็น &quot;หยุด&quot; แสดงว่าสคริปต์ Wikifxdefense Tianyan Shield ของบัญชีไม่ได้เป็นเช่นนั้น โหลดอยู่ในขณะนี้และจำเป็นต้องตรวจสอบให้ทันเวลาและโหลดอย่างถูกต้อง
                  </p>
                  <p>
                      บัญชี cTrader ในปัจจุบันจะไม่ปรากฏในรายการ
                  </p>
                  <p>
                      หากโหลด Sky Eye Shield สำเร็จ แอปจะแสดงตามปกติ แต่การแสดงอินเทอร์เฟซจะหยุดลง ซึ่งจะไม่ส่งผลกระทบต่อการใช้งานปกติ
                  </p>`,
        vi: `
        <div class="title-box">Các câu hỏi thường gặp</div>
                          <p class="bold">
                              1.Xử lý các lỗi kích hoạt thường gặp
                          </p>
                  <p>
                      1.1. Lỗi tải MT4:
                  </p>
                  <p>
                      DLL không được kiểm tra
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon1.png')}"/>
                  </p>
                  <p>
                      Giải pháp: Nhấp vào Tools-Options-EA Trading-DLL phía trên phần mềm giao dịch và kiểm tra để tải lại tập lệnh Sky Eye Shield.
                  </p>
                          <p class="bold">
                              2.Liên kết các máy chủ đám mây khác
                          </p>
                  <p>
                      Như được hiển thị bên dưới, điều đó có nghĩa là tài khoản được liên kết với các máy chủ đám mây khác và cần được liên kết với một tài khoản thực mới hoặc được liên kết với máy chủ đám mây trước khi đăng xuất. (IP máy chủ đám mây bị ràng buộc nằm trong hộp màu đỏ)
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon2.png')}"/>
                  </p>
                          <p class="bold">
                              3.Tài khoản giao dịch là tài khoản demo
                          </p>
                  <p>
                      (Tài khoản demo 1100010 không có sẵn)
                  </p>
                  <p>
                      Như hình bên dưới có nghĩa là bắt buộc phải ràng buộc với tài khoản thật, còn tài khoản demo không hỗ trợ ràng buộc.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon3.png')}"/>
                  </p>
                          <p class="bold">
                              4.Quá nhiều giao dịch
                          </p>
                  <p>
                      Người dùng thu hẹp phạm vi thời gian trong lịch sử tài khoản về tháng này hoặc tuần này, sau đó kích hoạt lại Sky Eye Shield.
                  </p>
                          <p class="bold">
                              5.Không lấy được thông tin người dùng
                          </p>
                  <p>
                      Như hình dưới có nghĩa là dữ liệu thông tin người dùng chưa được nhập vào thư mục phần mềm.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon4.png')}"/>
                  </p>
                  <p>
                      Giải pháp: Trong thiết bị đầu cuối MT4, chọn trang tab EA hoặc Nhật ký, chọn bất kỳ dòng nội dung nhật ký nào và nhấp chuột phải để chọn
                  </p>
                  <p>
                      Mở, như thể hiện trong hình:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon5.png')}"/>
                  </p>
                  <p>
                      Sau đó tìm thư mục MQL4&#92;Files tương ứng, chẳng hạn như:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon6.png')}"/>
                  </p>
                  <p>
                      Sau khi vào thư mục, kiểm tra xem có
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon7.png')}"/>
                  </p>
                  <p>
                      tập tin này. Nếu tệp tồn tại, hãy kiểm tra kích thước tệp. giống
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon8.png')}"/>
                  </p>
                  <p>
                      Nếu nó hiển thị 0Kb, nó chỉ ra một ngoại lệ. Các tập tin bình thường có thể được nhập thủ công.
                  </p>
                  <p>
                      Cách nhập: Mở thư mục phần mềm Sky Eye Shield, chọn biểu tượng phần mềm Sky Eye Shield trên màn hình desktop, nhấn chuột phải chọn
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon9.png')}"/>
                  </p>
                  <p>
                      Chỉ cần sao chép (ghi đè) file vào thư mục trên. Sau khi nhập thành công, hãy tải lại tập lệnh Sky Eye Shield.
                  </p>
                          <p class="bold">
                              6.Biện pháp phòng ngừa
                          </p>
                  <p>
                      6.1 Máy chủ đám mây phải đáp ứng tất cả các điều kiện gia hạn trước khi có thể sử dụng bình thường, nếu không sẽ bị thu hồi. Máy chủ đám mây mới mua phải đáp ứng các điều kiện gia hạn trong vòng 7 ngày.
                  </p>
                  <p>
                      6.2 Các điều kiện gia hạn là ràng buộc một tài khoản giao dịch thực (máy chủ đám mây độc quyền phải được liên kết với ít nhất một tài khoản nhà giao dịch độc quyền) và thực hiện giao dịch trên máy chủ đám mây mỗi tháng một lần. Máy chủ đám mây 1 nhân dân tệ và máy chủ đám mây 45 nhân dân tệ chỉ có thể được gia hạn nếu đáp ứng các điều kiện gia hạn. Máy chủ đám mây độc quyền miễn phí sẽ được tự động gia hạn miễn phí khi đáp ứng các điều kiện gia hạn.
                  </p>
                  <p>
                      6.3 Kênh hỏi đáp điều kiện gia hạn
                  </p>
                  <p>
                      Mở ỨNG DỤNG Forex Sky Eye, nhấp vào &quot;Tôi&quot;, &quot;VPS của tôi&quot;, sau đó nhấp vào &quot;Gia hạn ngay&quot; để xem.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon10.png')}"/>
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon11.png')}"/>
                  </p>
                  <p>
                      <span>Nếu phí gia hạn không được đáp ứng, vui lòng liên kết tài khoản giao dịch MT4/MT5 của bạn và hoàn tất giao dịch</span>
                  </p>
                          <p class="bold">
                              7.Mở thêm tài khoản
                          </p>
                  <p>
                      Nhấp chuột phải vào MT4 hoặc MT5 và mở vị trí tệp
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon12.png')}"/>
                  </p>
                  <p>
                      Nhấn vào đây để quay lại đường dẫn trước đó
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon13.png')}"/>
                  </p>
                  <p>
                      Copy toàn bộ thư mục MT4 hoặc MT5 ra desktop
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon14.png')}"/>
                  </p>
                  <p>
                      Mở tập tin trên máy tính để bàn
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon15.png')}"/>
                  </p>
                  <p>
                      Mở thư mục MT4 đã sao chép, tạo lối tắt ứng dụng và gửi nó ra màn hình nền.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon16.png')}"/>
                  </p>
                  <p>
                      Bạn có thể mở phần mềm giao dịch mới thông qua phím tắt trên màn hình, đăng nhập vào tài khoản khác và mở nhiều tài khoản.
                  </p>
                          <p class="bold">
                              8.Hướng dẫn sử dụng phần mềm Sky Eye Shield
                          </p>
                  <p>
                      Giới thiệu về Sky Eye Shield:
                  </p>
                  <p>
                      Sản phẩm phần mềm công nghệ cao đầu tiên và duy nhất trên thế giới có thể giám sát thông tin tài khoản giao dịch ngoại hối theo thời gian thực, khiến cho các chi phí ẩn không thể che giấu được.
                  </p>
                  <p>
                      8.1 Nhận ra sự kết nối giữa VPS và APP và bạn có thể xem thông tin giao dịch trong thời gian thực thông qua APP.
                  </p>
                  <p>
                      8.2. Giám sát thông tin tài khoản theo thời gian thực để đảm bảo an toàn cho các giao dịch của bạn.
                  </p>
                  <p>
                      8.3 Sử dụng công nghệ khai thác dữ liệu lớn và mạng lưới thần kinh để phát hiện chi phí giao dịch ẩn và chẩn đoán môi trường giao dịch trong thời gian thực
                  </p>
                  <p>
                      Phần mềm Sky Eye Shield khởi động ngẫu nhiên và đăng nhập tự động. Sau khi đăng nhập thành công, bạn có thể thấy phần mềm này trên khay hệ thống ở góc dưới bên phải của VPS.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon17.png')}"/>
                  </p>
                  <p>
                      Biểu tượng trên màn hình của phần mềm Sky Eye Shield:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon18.png')}"/>
                  </p>
                  <p>
                      Giao diện phần mềm Sky Eye Shield:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon19.png')}"/>
                  </p>
                  <p>
                      Trong danh sách người giao dịch được Tianyan Shield hiển thị, nếu trạng thái &quot;đang chạy&quot;, điều đó có nghĩa là tập lệnh Tianyan Shield của tài khoản đã được tải bình thường. Nếu trạng thái &quot;dừng&quot;, điều đó có nghĩa là tập lệnh Wikifxdefense Tianyan Shield của tài khoản không được tải. hiện đang được tải và cần được kiểm tra kịp thời và được tải chính xác.
                  </p>
                  <p>
                      Hiện tại tài khoản cTrader sẽ không xuất hiện trong danh sách.
                  </p>
                  <p>
                      Nếu Sky Eye Shield được tải thành công, APP sẽ hiển thị bình thường nhưng màn hình giao diện sẽ dừng, điều này không ảnh hưởng đến việc sử dụng bình thường. Màn hình cuối cùng sẽ tùy thuộc vào màn hình APP.
                  </p>`,
        id: `
        <div class="title-box">Pertanyaan yang Sering Diajukan</div>
                          <p class="bold">
                              1.Menangani kegagalan aktivasi yang umum
                          </p>
                  <p>
                      1.1.DLL tidak dicentang
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon1.png')}"/>
                  </p>
                  <p>
                      Solusi: Klik Tools-Options-EA Trading-DLL di atas perangkat lunak perdagangan dan centang untuk memuat ulang skrip Sky Eye Shield.
                  </p>
                          <p class="bold">
                              2.Ikat host cloud lainnya
                          </p>
                  <p>
                      Seperti yang ditunjukkan di bawah ini, ini berarti akun tersebut terikat ke host cloud lain dan harus terikat dengan akun nyata baru atau terikat ke host cloud sebelum keluar. (IP cloud host yang terikat ada di kotak merah)
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon2.png')}"/>
                  </p>
                          <p class="bold">
                              3.Akun perdagangan adalah akun demo
                          </p>
                  <p>
                      (Akun Demo 1100010 tidak tersedia)
                  </p>
                  <p>
                      Seperti yang ditunjukkan di bawah ini, ini berarti pengikatan dengan akun nyata diperlukan, dan akun demo tidak mendukung pengikatan.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon3.png')}"/>
                  </p>
                          <p class="bold">
                              4.Terlalu banyak transaksi
                          </p>
                  <p>
                      Pengguna mempersempit rentang waktu dalam riwayat akun menjadi bulan ini atau minggu ini, lalu mengaktifkan kembali Sky Eye Shield.
                  </p>
                          <p class="bold">
                              5.Informasi pengguna tidak diperoleh
                          </p>
                  <p>
                      Seperti gambar di bawah ini, berarti data informasi pengguna belum diimpor ke direktori perangkat lunak.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon4.png')}"/>
                  </p>
                  <p>
                      Solusi: Di terminal MT4, pilih halaman tab EA atau Log, pilih baris konten log mana pun, dan klik kanan untuk memilih
                  </p>
                  <p>
                      Buka, seperti yang ditunjukkan pada gambar:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon5.png')}"/>
                  </p>
                  <p>
                      Kemudian temukan direktori MQL4&#92;Files yang sesuai, seperti:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon6.png')}"/>
                  </p>
                  <p>
                      Setelah masuk ke direktori, periksa apakah ada
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon7.png')}"/>
                  </p>
                  <p>
                      file ini. Jika file ada, periksa ukuran file. menyukai
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon8.png')}"/>
                  </p>
                  <p>
                      Jika ini menampilkan 0Kb, ini menunjukkan pengecualian. File normal dapat diimpor secara manual.
                  </p>
                  <p>
                      Metode impor: Buka direktori perangkat lunak Sky Eye Shield, pilih ikon perangkat lunak Sky Eye Shield di desktop, klik kanan dan pilih
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon9.png')}"/>
                  </p>
                  <p>
                      Cukup salin (timpa) file tersebut ke direktori di atas. Setelah impor berhasil, muat ulang skrip Sky Eye Shield.
                  </p>
                          <p class="bold">
                              6.Tindakan Pencegahan
                          </p>
                  <p>
                      6.1. Cloud host harus memenuhi semua ketentuan pembaruan sebelum dapat digunakan secara normal, jika tidak maka akan ditarik. Host cloud yang baru dibeli harus memenuhi ketentuan perpanjangan dalam waktu 7 hari.
                  </p>
                  <p>
                      6.2. Ketentuan perpanjangannya adalah mengikat akun perdagangan nyata (host cloud eksklusif harus terikat ke setidaknya satu akun pedagang eksklusif) dan melakukan transaksi di host cloud sebulan sekali. Host cloud 1 yuan dan host cloud 45 yuan hanya dapat diperpanjang jika ketentuan pembaruan terpenuhi. Host cloud eksklusif gratis akan diperpanjang secara otomatis secara gratis ketika ketentuan pembaruan terpenuhi.
                  </p>
                  <p>
                      6.3. Saluran pertanyaan untuk ketentuan pembaruan
                  </p>
                  <p>
                      Buka APLIKASI Forex Sky Eye, klik &quot;Saya&quot;, &quot;VPS Saya&quot;, lalu klik &quot;Perbarui Sekarang&quot; untuk melihatnya.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon10.png')}"/>
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon11.png')}"/>
                  </p>
                  <p>
                      <span>Jika biaya perpanjangan tidak terpenuhi, harap ikat akun perdagangan MT4/MT5 Anda dan selesaikan transaksi</span>
                  </p>
                          <p class="bold">
                              7.Buka lebih banyak akun
                          </p>
                  <p>
                      Klik kanan pada MT4 atau MT5 dan buka lokasi file
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon12.png')}"/>
                  </p>
                  <p>
                      Klik di sini untuk kembali ke jalur sebelumnya
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon13.png')}"/>
                  </p>
                  <p>
                      Salin seluruh folder MT4 atau MT5 ke desktop
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon14.png')}"/>
                  </p>
                  <p>
                      Buka file di desktop
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon15.png')}"/>
                  </p>
                  <p>
                      Buka folder MT4 yang disalin, buat pintasan aplikasi, dan kirimkan ke desktop.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon16.png')}"/>
                  </p>
                  <p>
                      Anda dapat membuka software trading baru melalui shortcut di desktop, masuk ke akun lain, dan membuka banyak akun.
                  </p>
                          <p class="bold">
                              8.Petunjuk Perangkat Lunak Sky Eye Shield
                          </p>
                  <p>
                      Pengantar Pelindung Mata Langit:
                  </p>
                  <p>
                      Produk perangkat lunak berteknologi tinggi pertama dan satu-satunya di dunia yang dapat memantau informasi akun perdagangan valuta asing secara real time, sehingga biaya tersembunyi tidak dapat disembunyikan.
                  </p>
                  <p>
                      8.1. Sadarilah interkoneksi antara VPS dan APP, dan Anda dapat melihat informasi transaksi secara real time melalui APP.
                  </p>
                  <p>
                      8.2. Pantau informasi akun secara real time untuk memastikan keamanan transaksi Anda.
                  </p>
                  <p>
                      8.3. Menggunakan penambangan data besar dan teknologi jaringan saraf untuk mendeteksi biaya transaksi tersembunyi dan mendiagnosis lingkungan perdagangan secara real time
                  </p>
                  <p>
                      Software Sky Eye Shield dimulai secara acak dan login secara otomatis. Setelah berhasil login, dapat dilihat pada system tray di pojok kanan bawah VPS.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon17.png')}"/>
                  </p>
                  <p>
                      Ikon desktop perangkat lunak Sky Eye Shield:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon18.png')}"/>
                  </p>
                  <p>
                      Antarmuka perangkat lunak Sky Eye Shield:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon19.png')}"/>
                  </p>
                  <p>
                      Pada daftar trader yang ditampilkan oleh Tianyan Shield, jika statusnya &quot;running&quot; berarti skrip Tianyan Shield akun telah dimuat secara normal. Jika statusnya &quot;stop&quot; berarti skrip Wikifxdefense Tianyan Shield akun tersebut tidak saat ini dimuat dan perlu diperiksa tepat waktu dan Dimuat dengan benar.
                  </p>
                  <p>
                      Saat ini akun cTrader tidak akan muncul dalam daftar.
                  </p>
                  <p>
                      Jika Sky Eye Shield berhasil dimuat, APLIKASI ditampilkan secara normal tetapi tampilan antarmuka berhenti, yang tidak mempengaruhi penggunaan normal.
                  </p>`,
        es: `
        <div class="title-box">Preguntas frecuentes</div>
                          <p class="bold">
                              4.Manejo de fallas de activación comunes
                          </p>
                  <p>
                      1.1. Fallo de carga de MT4:
                  </p>
                  <p>
                      DLL no está marcada
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon1.png')}"/>
                  </p>
                  <p>
                      Solución: haga clic en Herramientas-Opciones-EA Trading-DLL encima del software comercial y verifique para recargar el script Sky Eye Shield.
                  </p>
                          <p class="bold">
                              2.Vincular otros hosts en la nube
                          </p>
                  <p>
                      Como se muestra a continuación, significa que la cuenta está vinculada a otros hosts en la nube y debe vincularse a una nueva cuenta real o al host en la nube antes de cerrar sesión. (La IP del host de la nube vinculada está en el cuadro rojo)
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon2.png')}"/>
                  </p>
                          <p class="bold">
                              3.La cuenta comercial es una cuenta demo.
                          </p>
                  <p>
                      (La cuenta demo 1100010 no está disponible)
                  </p>
                  <p>
                      Como se muestra a continuación, significa que se requiere la vinculación con una cuenta real y la cuenta de demostración no admite la vinculación.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon3.png')}"/>
                  </p>
                          <p class="bold">
                              4.Demasiadas transacciones
                          </p>
                  <p>
                      El usuario reduce el rango de tiempo en el historial de la cuenta a este mes o esta semana y luego reactiva Sky Eye Shield.
                  </p>
                          <p class="bold">
                              5.Información del usuario no obtenida
                          </p>
                  <p>
                      Como se muestra a continuación, significa que los datos de información del usuario no se han importado al directorio del software.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon4.png')}"/>
                  </p>
                  <p>
                      Solución: en la terminal MT4, seleccione la pestaña EA o Registro, seleccione cualquier línea de contenido del registro y haga clic derecho para seleccionar
                  </p>
                  <p>
                      Abierto, como se muestra en la figura:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon5.png')}"/>
                  </p>
                  <p>
                      Luego busque el directorio MQL4&#92;Files correspondiente, como por ejemplo:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon6.png')}"/>
                  </p>
                  <p>
                      Después de ingresar al directorio, verifique si hay
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon7.png')}"/>
                  </p>
                  <p>
                      Este archivo. Si el archivo existe, verifique el tamaño del archivo. como
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon8.png')}"/>
                  </p>
                  <p>
                      Si muestra 0Kb, indica una excepción. Los archivos normales se pueden importar manualmente.
                  </p>
                  <p>
                      Método de importación: abra el directorio del software Sky Eye Shield, seleccione el icono del software Sky Eye Shield en el escritorio, haga clic derecho y seleccione el
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon9.png')}"/>
                  </p>
                  <p>
                      Simplemente copie (sobrescriba) el archivo en el directorio anterior. Una vez que la importación se haya realizado correctamente, vuelva a cargar el script Sky Eye Shield.
                  </p>
                          <p class="bold">
                              6.Precauciones
                          </p>
                  <p>
                      6.1. El host de la nube debe cumplir con todas las condiciones de renovación antes de poder usarse normalmente; de lo contrario, será retirado. Los hosts en la nube recién adquiridos deben cumplir las condiciones de renovación en un plazo de 7 días.
                  </p>
                  <p>
                      6.2 Las condiciones de renovación son vincular una cuenta comercial real (el host exclusivo en la nube debe estar vinculado al menos a una cuenta comercial exclusiva) y realizar una transacción en el host en la nube una vez al mes. El host en la nube de 1 yuan y el host en la nube de 45 yuanes se pueden renovar solo si se cumplen las condiciones de renovación. El host en la nube exclusivo y gratuito se renovará automáticamente de forma gratuita cuando se cumplan las condiciones de renovación.
                  </p>
                  <p>
                      6.3. Canales de consulta de condiciones de renovación
                  </p>
                  <p>
                      Abra la aplicación Forex Sky Eye, haga clic en &quot;Yo&quot;, &quot;Mi VPS&quot; y luego haga clic en &quot;Renovar ahora&quot; para ver.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon10.png')}"/>
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon11.png')}"/>
                  </p>
                  <p>
                      <span>Si no se satisface la tarifa de renovación, vincule su cuenta comercial MT4/MT5 y complete una transacción.</span>
                  </p>
                          <p class="bold">
                              7.Abre más cuentas
                          </p>
                  <p>
                      Haga clic derecho en MT4 o MT5 y abra la ubicación del archivo
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon12.png')}"/>
                  </p>
                  <p>
                      Haga clic aquí para volver a la ruta anterior
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon13.png')}"/>
                  </p>
                  <p>
                      Copie toda la carpeta MT4 o MT5 al escritorio
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon14.png')}"/>
                  </p>
                  <p>
                      Abrir archivo en el escritorio
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon15.png')}"/>
                  </p>
                  <p>
                      Abra la carpeta MT4 copiada, cree un acceso directo a la aplicación y envíelo al escritorio.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon16.png')}"/>
                  </p>
                  <p>
                      Puede abrir un nuevo software comercial a través de un acceso directo en el escritorio, iniciar sesión en otra cuenta y abrir varias cuentas.
                  </p>
                          <p class="bold">
                              8.Instrucciones del software Sky Eye Shield
                          </p>
                  <p>
                      Introducción al Sky Eye Shield:
                  </p>
                  <p>
                      El primer y único producto de software de alta tecnología del mundo que puede monitorear la información de la cuenta de operaciones de cambio de divisas en tiempo real, haciendo que los costos ocultos no queden ocultos.
                  </p>
                  <p>
                      8.1 Realice la interconexión entre VPS y la APLICACIÓN, y podrá ver la información de la transacción en tiempo real a través de la APLICACIÓN.
                  </p>
                  <p>
                      8.2. Monitorear la información de la cuenta en tiempo real para garantizar la seguridad de sus transacciones.
                  </p>
                  <p>
                      8.3 Utilice tecnología de redes neuronales y minería de big data para detectar costos de transacción ocultos y diagnosticar el entorno comercial en tiempo real.
                  </p>
                  <p>
                      El software Sky Eye Shield se inicia aleatoriamente e inicia sesión automáticamente. Después de iniciar sesión correctamente, se puede ver en la bandeja del sistema en la esquina inferior derecha del VPS.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon17.png')}"/>
                  </p>
                  <p>
                      Ícono del escritorio del software Sky Eye Shield:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon18.png')}"/>
                  </p>
                  <p>
                      Interfaz del software Sky Eye Shield:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon19.png')}"/>
                  </p>
                  <p>
                      En la lista de comerciantes que muestra Tianyan Shield, si el estado es &quot;en ejecución&quot;, significa que el script Tianyan Shield de la cuenta se ha cargado normalmente. Si el estado es &quot;detenido&quot;, significa que el script Wikifxdefense Tianyan Shield de la cuenta no lo está. actualmente cargado y debe verificarse a tiempo y cargarse correctamente.
                  </p>
                  <p>
                      Actualmente, las cuentas de cTrader no aparecerán en la lista.
                  </p>
                  <p>
                      Si Sky Eye Shield se carga correctamente, la aplicación se muestra normalmente pero la visualización de la interfaz se detiene, lo que no afecta el uso normal. La visualización final estará sujeta a la visualización de la aplicación.
                  </p>`,
        hi: `
        <div class="title-box">अक्सर पूछे जाने वाले प्रश्नों</div>
                          <p class="bold">
                              1.सामान्य सक्रियण विफलताओं को संभालना
                          </p>
                  <p>
                      1.1. एमटी4 लोडिंग विफलता:
                  </p>
                  <p>
                      DLL की जाँच नहीं की गई है
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon1.png')}"/>
                  </p>
                  <p>
                      समाधान: ट्रेडिंग सॉफ्टवेयर के ऊपर टूल्स-ऑप्शंस-ईए ट्रेडिंग-डीएलएल पर क्लिक करें और स्काई आई शील्ड स्क्रिप्ट को फिर से लोड करने के लिए जांचें।
                  </p>
                          <p class="bold">
                              2.अन्य क्लाउड होस्ट को बाइंड करें
                          </p>
                  <p>
                      जैसा कि नीचे दिखाया गया है, इसका मतलब है कि खाता अन्य क्लाउड होस्ट से बंधा हुआ है और लॉग आउट करने से पहले उसे एक नए वास्तविक खाते से बंधा होना चाहिए या क्लाउड होस्ट से बंधा होना चाहिए। (बाउंड क्लाउड होस्ट आईपी लाल बॉक्स में है)
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon2.png')}"/>
                  </p>
                          <p class="bold">
                              3.ट्रेडिंग अकाउंट एक डेमो अकाउंट है
                          </p>
                  <p>
                      (1100010 डेमो खाता उपलब्ध नहीं है)
                  </p>
                  <p>
                      जैसा कि नीचे दिखाया गया है, इसका मतलब है कि वास्तविक खाते के साथ बाइंडिंग आवश्यक है, और डेमो अकाउंट बाइंडिंग का समर्थन नहीं करता है।
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon3.png')}"/>
                  </p>
                          <p class="bold">
                              4.बहुत अधिक लेन-देन
                          </p>
                  <p>
                      उपयोगकर्ता खाता इतिहास में समय सीमा को इस महीने या इस सप्ताह तक सीमित करता है, और फिर स्काई आई शील्ड को पुनः सक्रिय करता है।
                  </p>
                          <p class="bold">
                              5.उपयोगकर्ता की जानकारी प्राप्त नहीं हुई
                          </p>
                  <p>
                      जैसा कि नीचे दिखाया गया है, इसका मतलब है कि उपयोगकर्ता सूचना डेटा को सॉफ़्टवेयर निर्देशिका में आयात नहीं किया गया है।
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon4.png')}"/>
                  </p>
                  <p>
                      समाधान: MT4 टर्मिनल में, EA या लॉग टैब पृष्ठ का चयन करें, लॉग सामग्री की किसी भी पंक्ति का चयन करें, और चयन करने के लिए राइट-क्लिक करें
                  </p>
                  <p>
                      खोलें, जैसा चित्र में दिखाया गया है:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon5.png')}"/>
                  </p>
                  <p>
                      फिर संबंधित MQL4&#92;Files निर्देशिका ढूंढें, जैसे:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon6.png')}"/>
                  </p>
                  <p>
                      डायरेक्टरी में प्रवेश करने के बाद जांचें कि क्या वहां है
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon7.png')}"/>
                  </p>
                  <p>
                      यह फ़ाइल। यदि फ़ाइल मौजूद है, तो फ़ाइल का आकार जांचें। पसंद
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon8.png')}"/>
                  </p>
                  <p>
                      यदि यह 0Kb प्रदर्शित करता है, तो यह एक अपवाद को इंगित करता है। सामान्य फ़ाइलें मैन्युअल रूप से आयात की जा सकती हैं.
                  </p>
                  <p>
                      आयात विधि: स्काई आई शील्ड सॉफ़्टवेयर निर्देशिका खोलें, डेस्कटॉप पर स्काई आई शील्ड सॉफ़्टवेयर आइकन चुनें, राइट-क्लिक करें और चुनें
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon9.png')}"/>
                  </p>
                  <p>
                      बस फ़ाइल को उपरोक्त निर्देशिका में कॉपी (ओवरराइट) करें। आयात सफल होने के बाद, स्काई आई शील्ड स्क्रिप्ट को पुनः लोड करें।
                  </p>
                          <p class="bold">
                              6.सावधानियां
                          </p>
                  <p>
                      6.1. क्लाउड होस्ट को सामान्य रूप से उपयोग करने से पहले सभी नवीनीकरण शर्तों को पूरा करना होगा, अन्यथा इसे वापस ले लिया जाएगा। नए खरीदे गए क्लाउड होस्ट को 7 दिनों के भीतर नवीनीकरण शर्तों को पूरा करना होगा।
                  </p>
                  <p>
                      6.2. नवीनीकरण की शर्तें एक वास्तविक ट्रेडिंग खाते को बाध्य करना है (विशेष क्लाउड होस्ट को कम से कम एक विशिष्ट व्यापारी खाते से बाध्य होना चाहिए) और महीने में एक बार क्लाउड होस्ट पर लेनदेन करना है। 1-युआन क्लाउड होस्ट और 45-युआन क्लाउड होस्ट को केवल तभी नवीनीकृत किया जा सकता है जब नवीनीकरण की शर्तें पूरी होती हैं। नवीनीकरण की शर्तें पूरी होने पर मुफ्त एक्सक्लूसिव क्लाउड होस्ट स्वचालित रूप से मुफ्त में नवीनीकृत हो जाएगा।
                  </p>
                  <p>
                      6.3. नवीनीकरण शर्तों के लिए पूछताछ चैनल
                  </p>
                  <p>
                      फ़ॉरेक्स स्काई आई ऐप खोलें, &quot;मी&quot;, &quot;माई वीपीएस&quot; पर क्लिक करें और फिर देखने के लिए &quot;अभी नवीनीकृत करें&quot; पर क्लिक करें।
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon10.png')}"/>
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon11.png')}"/>
                  </p>
                  <p>
                      <span>यदि नवीनीकरण शुल्क संतुष्ट नहीं है, तो कृपया अपने MT4/MT5 ट्रेडिंग खाते को बाध्य करें और लेनदेन पूरा करें</span>
                  </p>
                          <p class="bold">
                              7.अधिक खाते खोलें
                          </p>
                  <p>
                      MT4 या MT5 पर राइट क्लिक करें और फ़ाइल स्थान खोलें
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon12.png')}"/>
                  </p>
                  <p>
                      पिछले पथ पर लौटने के लिए यहां क्लिक करें
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon13.png')}"/>
                  </p>
                  <p>
                      संपूर्ण MT4 या MT5 फ़ोल्डर को डेस्कटॉप पर कॉपी करें
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon14.png')}"/>
                  </p>
                  <p>
                      डेस्कटॉप पर फ़ाइल खोलें
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon15.png')}"/>
                  </p>
                  <p>
                      कॉपी किए गए MT4 फ़ोल्डर को खोलें, एक एप्लिकेशन शॉर्टकट बनाएं और इसे डेस्कटॉप पर भेजें।
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon16.png')}"/>
                  </p>
                  <p>
                      आप डेस्कटॉप पर शॉर्टकट के माध्यम से नया ट्रेडिंग सॉफ्टवेयर खोल सकते हैं, दूसरे खाते में लॉग इन कर सकते हैं और कई खाते खोल सकते हैं।
                  </p>
                          <p class="bold">
                              8.स्काई आई शील्ड सॉफ्टवेयर निर्देश
                          </p>
                  <p>
                      स्काई आई शील्ड का परिचय:
                  </p>
                  <p>
                      दुनिया का पहला और एकमात्र हाई-टेक सॉफ्टवेयर उत्पाद जो वास्तविक समय में विदेशी मुद्रा व्यापार खाते की जानकारी की निगरानी कर सकता है, जिससे छिपी हुई लागतों को छुपाने की जगह नहीं मिलती है।
                  </p>
                  <p>
                      8.1. वीपीएस और एपीपी के बीच अंतरसंबंध को समझें, और आप एपीपी के माध्यम से वास्तविक समय में लेनदेन की जानकारी देख सकते हैं।
                  </p>
                  <p>
                      8.2. अपने लेनदेन की सुरक्षा सुनिश्चित करने के लिए वास्तविक समय में खाते की जानकारी की निगरानी करें।
                  </p>
                  <p>
                      8.3. छिपी हुई लेनदेन लागतों का पता लगाने और वास्तविक समय में व्यापारिक वातावरण का निदान करने के लिए बड़े डेटा खनन और तंत्रिका नेटवर्क तकनीक का उपयोग करें
                  </p>
                  <p>
                      स्काई आई शील्ड सॉफ़्टवेयर यादृच्छिक रूप से प्रारंभ होता है और स्वचालित रूप से लॉग इन होता है, सफल लॉगिन के बाद, इसे वीपीएस के निचले दाएं कोने में सिस्टम ट्रे में देखा जा सकता है।
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon17.png')}"/>
                  </p>
                  <p>
                      स्काई आई शील्ड सॉफ्टवेयर डेस्कटॉप आइकन:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon18.png')}"/>
                  </p>
                  <p>
                      स्काई आई शील्ड सॉफ्टवेयर इंटरफ़ेस:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon19.png')}"/>
                  </p>
                  <p>
                      तियान्यान शील्ड द्वारा प्रदर्शित व्यापारियों की सूची में, यदि स्थिति &quot;चल रही है&quot; है, तो इसका मतलब है कि खाते की तियान्यान शील्ड स्क्रिप्ट सामान्य रूप से लोड की गई है। यदि स्थिति &quot;बंद&quot; है, तो इसका मतलब है कि खाते की विकिफएक्सडिफेंस तियान्यान शील्ड स्क्रिप्ट नहीं है। वर्तमान में लोड किया गया है और इसे समय पर जांचने और सही ढंग से लोड करने की आवश्यकता है।
                  </p>
                  <p>
                      वर्तमान में cTrader खाते सूची में दिखाई नहीं देंगे।
                  </p>
                  <p>
                      यदि स्काई आई शील्ड सफलतापूर्वक लोड हो जाती है, तो एपीपी सामान्य रूप से प्रदर्शित होता है लेकिन इंटरफ़ेस डिस्प्ले बंद हो जाता है, जो सामान्य उपयोग को प्रभावित नहीं करता है। अंतिम डिस्प्ले एपीपी डिस्प्ले के अधीन होगा।
                  </p>`,
        fil: `
        <div class="title-box">Mga Madalas Itanong</div>
                          <p class="bold">
                              1.Pangangasiwa sa mga karaniwang pagkabigo sa pag-activate
                          </p>
                  <p>
                      1.1. Nabigo ang paglo-load ng MT4:
                  </p>
                  <p>
                      Ang DLL ay hindi nasuri
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon1.png')}"/>
                  </p>
                  <p>
                      Solusyon: I-click ang Tools-Options-EA Trading-DLL sa itaas ng software ng kalakalan at suriin upang i-reload ang script ng Sky Eye Shield.
                  </p>
                          <p class="bold">
                              2.Itali ang iba pang cloud host
                          </p>
                  <p>
                      Gaya ng ipinapakita sa ibaba, nangangahulugan ito na ang account ay nakatali sa iba pang cloud host at kailangang itali sa isang bagong real account o nakatali sa cloud host bago mag-log out. (Ang nakatali na cloud host IP ay nasa pulang kahon)
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon2.png')}"/>
                  </p>
                          <p class="bold">
                              3.Ang trading account ay isang demo account
                          </p>
                  <p>
                      (1100010 Demo Account ay hindi magagamit)
                  </p>
                  <p>
                      Gaya ng ipinapakita sa ibaba, nangangahulugan ito na kailangan ang pag-binding sa totoong account, at hindi sinusuportahan ng demo account ang pag-binding.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon3.png')}"/>
                  </p>
                          <p class="bold">
                              4.Masyadong maraming transaksyon
                          </p>
                  <p>
                      Ang user ay nagpapaliit sa hanay ng oras sa kasaysayan ng account sa buwang ito o sa linggong ito, at pagkatapos ay muling i-activate ang Sky Eye Shield.
                  </p>
                          <p class="bold">
                              5.Hindi nakuha ang impormasyon ng user
                          </p>
                  <p>
                      Gaya ng ipinapakita sa ibaba, nangangahulugan ito na ang data ng impormasyon ng user ay hindi pa na-import sa direktoryo ng software.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon4.png')}"/>
                  </p>
                  <p>
                      Solusyon: Sa terminal ng MT4, piliin ang pahina ng tab na EA o Log, piliin ang anumang linya ng nilalaman ng log, at i-right-click upang piliin
                  </p>
                  <p>
                      Buksan, tulad ng ipinapakita sa figure:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon5.png')}"/>
                  </p>
                  <p>
                      Pagkatapos ay hanapin ang kaukulang MQL4&#92;Files na direktoryo, tulad ng:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon6.png')}"/>
                  </p>
                  <p>
                      Pagkatapos ipasok ang direktoryo, suriin kung mayroon
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon7.png')}"/>
                  </p>
                  <p>
                      ang file na ito. Kung umiiral ang file, suriin ang laki ng file. gaya ng
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon8.png')}"/>
                  </p>
                  <p>
                      Kung ito ay nagpapakita ng 0Kb, ito ay nagpapahiwatig ng isang pagbubukod. Ang mga normal na file ay maaaring i-import nang manu-mano.
                  </p>
                  <p>
                      Paraan ng pag-import: Buksan ang direktoryo ng software ng Sky Eye Shield, piliin ang icon ng software ng Sky Eye Shield sa desktop, i-right click at piliin ang
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon9.png')}"/>
                  </p>
                  <p>
                      Kopyahin lamang (i-overwrite) ang file sa direktoryo sa itaas. Matapos matagumpay ang pag-import, i-reload ang script ng Sky Eye Shield.
                  </p>
                          <p class="bold">
                              6.Pag-iingat
                          </p>
                  <p>
                      6.1. Dapat matugunan ng cloud host ang lahat ng kundisyon sa pag-renew bago ito magamit nang normal, kung hindi, ito ay aalisin. Dapat matugunan ng mga bagong binili na cloud host ang mga kundisyon sa pag-renew sa loob ng 7 araw.
                  </p>
                  <p>
                      6.2. Ang mga kundisyon sa pag-renew ay upang isailalim ang isang tunay na trading account (ang eksklusibong cloud host ay dapat na nakatali sa hindi bababa sa isang eksklusibong trader account) at magsagawa ng transaksyon sa cloud host isang beses sa isang buwan. Ang 1-yuan na cloud host at ang 45-yuan na cloud host ay maaaring i-renew lamang kung ang mga kondisyon sa pag-renew ay natutugunan Ang libreng eksklusibong cloud host ay awtomatikong mare-renew nang libre kapag natugunan ang mga kondisyon sa pag-renew.
                  </p>
                  <p>
                      6.3. Mga channel ng pagtatanong para sa mga kondisyon sa pag-renew
                  </p>
                  <p>
                      Buksan ang Forex Sky Eye APP, i-click ang &quot;Me&quot;, &quot;My VPS&quot;, at pagkatapos ay i-click ang &quot;Renew Now&quot; para tingnan.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon10.png')}"/>
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon11.png')}"/>
                  </p>
                  <p>
                      <span>Kung hindi nasiyahan ang bayad sa pag-renew, mangyaring itali ang iyong MT4/MT5 trading account at kumpletuhin ang isang transaksyon</span>
                  </p>
                          <p class="bold">
                              7.Magbukas ng higit pang mga account
                          </p>
                  <p>
                      Mag-right click sa MT4 o MT5 at buksan ang lokasyon ng file
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon12.png')}"/>
                  </p>
                  <p>
                      Mag-click dito upang bumalik sa nakaraang landas
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon13.png')}"/>
                  </p>
                  <p>
                      Kopyahin ang buong folder ng MT4 o MT5 sa desktop
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon14.png')}"/>
                  </p>
                  <p>
                      Buksan ang file sa desktop
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon15.png')}"/>
                  </p>
                  <p>
                      Buksan ang nakopyang MT4 na folder, lumikha ng isang application shortcut, at ipadala ito sa desktop.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon16.png')}"/>
                  </p>
                  <p>
                      Maaari kang magbukas ng bagong software ng kalakalan sa pamamagitan ng isang shortcut sa desktop, mag-log in sa isa pang account, at magbukas ng maraming account.
                  </p>
                          <p class="bold">
                              8.Mga Tagubilin sa Software ng Sky Eye Shield
                          </p>
                  <p>
                      Panimula sa Sky Eye Shield:
                  </p>
                  <p>
                      Ang una at tanging high-tech na software na produkto sa mundo na maaaring sumubaybay sa impormasyon ng foreign exchange trading account sa real time, na ginagawang hindi maitatago ang mga nakatagong gastos.
                  </p>
                  <p>
                      8.1. Napagtanto ang pagkakaugnay sa pagitan ng VPS at APP, at maaari mong tingnan ang impormasyon ng transaksyon sa real time sa pamamagitan ng APP.
                  </p>
                  <p>
                      8.2. Subaybayan ang impormasyon ng account sa real time upang matiyak ang kaligtasan ng iyong mga transaksyon.
                  </p>
                  <p>
                      8.3. Gumamit ng malaking data mining at neural network na teknolohiya upang makita ang mga nakatagong gastos sa transaksyon at masuri ang kapaligiran ng kalakalan sa real time
                  </p>
                  <p>
                      Ang software ng Sky Eye Shield ay random na nagsisimula at awtomatikong nagla-log in Pagkatapos ng matagumpay na pag-log in, makikita ito sa system tray sa kanang sulok sa ibaba ng VPS.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon17.png')}"/>
                  </p>
                  <p>
                      Icon ng desktop ng Sky Eye Shield software:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon18.png')}"/>
                  </p>
                  <p>
                      Interface ng software ng Sky Eye Shield:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon19.png')}"/>
                  </p>
                  <p>
                      Sa listahan ng mga mangangalakal na ipinakita ng Tianyan Shield, kung ang status ay &quot;tumatakbo&quot;, nangangahulugan ito na ang script ng Tianyan Shield ng account ay na-load nang normal Kung ang status ay &quot;itinigil&quot;, nangangahulugan ito na ang script ng Wikifxdefense Tianyan Shield ng account ay hindi kasalukuyang na-load at kailangang suriin sa oras at Na-load nang tama.
                  </p>
                  <p>
                      Kasalukuyang hindi lalabas sa listahan ang mga cTrader account.
                  </p>
                  <p>
                      Kung matagumpay na na-load ang Sky Eye Shield, normal na ipinapakita ang APP ngunit hihinto ang display ng interface, na hindi makakaapekto sa normal na paggamit Ang panghuling display ay sasailalim sa display ng APP.
                  </p>`,
        fr: `
        <div class="title-box">Questions fréquemment posées</div>
                          <p class="bold">
                              1.Gestion des échecs d&#39;activation courants
                          </p>
                  <p>
                      1.1. Échec du chargement de MT4&nbsp;:
                  </p>
                  <p>
                      La DLL n&#39;est pas vérifiée
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon1.png')}"/>
                  </p>
                  <p>
                      Solution : Cliquez sur Outils-Options-EA Trading-DLL au-dessus du logiciel de trading et cochez pour recharger le script Sky Eye Shield.
                  </p>
                          <p class="bold">
                              2.Liez d&#39;autres hôtes cloud
                          </p>
                  <p>
                      Comme indiqué ci-dessous, cela signifie que le compte est lié à d&#39;autres hôtes cloud et doit être lié à un nouveau compte réel ou lié à l&#39;hôte cloud avant de se déconnecter. (L&#39;adresse IP de l&#39;hôte cloud lié se trouve dans la case rouge)
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon2.png')}"/>
                  </p>
                          <p class="bold">
                              3.Le compte de trading est un compte démo
                          </p>
                  <p>
                      (Le compte démo 1100010 n&#39;est pas disponible)
                  </p>
                  <p>
                      Comme indiqué ci-dessous, cela signifie que la liaison avec un compte réel est requise et que le compte démo ne prend pas en charge la liaison.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon3.png')}"/>
                  </p>
                          <p class="bold">
                              4.Trop de transactions
                          </p>
                  <p>
                      L&#39;utilisateur réduit la plage de temps dans l&#39;historique du compte à ce mois ou cette semaine, puis réactive le Sky Eye Shield.
                  </p>
                          <p class="bold">
                              5.Informations utilisateur non obtenues
                          </p>
                  <p>
                      Comme indiqué ci-dessous, cela signifie que les données d&#39;informations utilisateur n&#39;ont pas été importées dans le répertoire du logiciel.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon4.png')}"/>
                  </p>
                  <p>
                      Solution&nbsp;: dans le terminal MT4, sélectionnez la page à onglet EA ou Log, sélectionnez n&#39;importe quelle ligne de contenu du journal et cliquez avec le bouton droit pour sélectionner
                  </p>
                  <p>
                      Ouvert, comme indiqué sur la figure&nbsp;:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon5.png')}"/>
                  </p>
                  <p>
                      Recherchez ensuite le répertoire MQL4&#92;Files correspondant, tel que&nbsp;:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon6.png')}"/>
                  </p>
                  <p>
                      Après avoir accédé au répertoire, vérifiez s&#39;il existe
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon7.png')}"/>
                  </p>
                  <p>
                      ce fichier. Si le fichier existe, vérifiez sa taille. comme
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon8.png')}"/>
                  </p>
                  <p>
                      S&#39;il affiche 0 Ko, cela indique une exception. Les fichiers normaux peuvent être importés manuellement.
                  </p>
                  <p>
                      Méthode d&#39;importation&nbsp;: ouvrez le répertoire du logiciel Sky Eye Shield, sélectionnez l&#39;icône du logiciel Sky Eye Shield sur le bureau, cliquez avec le bouton droit et sélectionnez le
                  </p>
                  <p>
                      [image]
                  </p>
                  <p>
                      Copiez (écrasez) simplement le fichier dans le répertoire ci-dessus. Une fois l&#39;importation réussie, rechargez le script Sky Eye Shield.
                  </p>
                          <p class="bold">
                              6.Précautions
                          </p>
                  <p>
                      6.1. L&#39;hébergeur cloud doit remplir toutes les conditions de renouvellement avant de pouvoir être utilisé normalement, sinon il sera retiré. Les hôtes cloud nouvellement achetés doivent remplir les conditions de renouvellement dans les 7 jours.
                  </p>
                  <p>
                      6.2. Les conditions de renouvellement sont de lier un compte de trading réel (l&#39;hébergeur cloud exclusif doit être lié à au moins un compte trader exclusif) et d&#39;effectuer une transaction sur l&#39;hébergeur cloud une fois par mois. L&#39;hôte cloud à 1 yuan et l&#39;hôte cloud à 45 yuans ne peuvent être renouvelés que si les conditions de renouvellement sont remplies. L&#39;hôte cloud exclusif gratuit sera automatiquement renouvelé gratuitement lorsque les conditions de renouvellement sont remplies.
                  </p>
                  <p>
                      6.3. Canaux de demande de conditions de renouvellement
                  </p>
                  <p>
                      Ouvrez l&#39;application Forex Sky Eye, cliquez sur « Moi », « Mon VPS », puis cliquez sur « Renouveler maintenant » pour afficher.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon10.png')}"/>
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon11.png')}"/>
                  </p>
                  <p>
                      <span>Si les frais de renouvellement ne sont pas satisfaits, veuillez lier votre compte de trading MT4/MT5 et effectuer une transaction</span>
                  </p>
                          <p class="bold">
                              7.Ouvrez plus de comptes
                          </p>
                  <p>
                      Faites un clic droit sur MT4 ou MT5 et ouvrez l&#39;emplacement du fichier
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon12.png')}"/>
                  </p>
                  <p>
                      Cliquez ici pour revenir au chemin précédent
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon13.png')}"/>
                  </p>
                  <p>
                      Copiez l&#39;intégralité du dossier MT4 ou MT5 sur le bureau
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon14.png')}"/>
                  </p>
                  <p>
                      Ouvrir le fichier sur le bureau
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon15.png')}"/>
                  </p>
                  <p>
                      Ouvrez le dossier MT4 copié, créez un raccourci d&#39;application et envoyez-le sur le bureau.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon16.png')}"/>
                  </p>
                  <p>
                      Vous pouvez ouvrir un nouveau logiciel de trading via un raccourci sur le bureau, vous connecter à un autre compte et ouvrir plusieurs comptes.
                  </p>
                          <p class="bold">
                              8.Instructions du logiciel Sky Eye Shield
                          </p>
                  <p>
                      Introduction au Sky Eye Shield&nbsp;:
                  </p>
                  <p>
                      Le premier et le seul produit logiciel de haute technologie au monde capable de surveiller les informations sur les comptes de trading de devises en temps réel, rendant ainsi les coûts cachés impossibles à cacher.
                  </p>
                  <p>
                      8.1. Réalisez l&#39;interconnexion entre VPS et APP, et vous pouvez afficher les informations de transaction en temps réel via l&#39;APP.
                  </p>
                  <p>
                      8.2. Surveillez les informations du compte en temps réel pour assurer la sécurité de vos transactions.
                  </p>
                  <p>
                      8.3. Utiliser la technologie d&#39;exploration de données massives et de réseaux neuronaux pour détecter les coûts de transaction cachés et diagnostiquer l&#39;environnement commercial en temps réel
                  </p>
                  <p>
                      Le logiciel Sky Eye Shield démarre de manière aléatoire et se connecte automatiquement. Après une connexion réussie, il est visible dans la barre d&#39;état système dans le coin inférieur droit du VPS.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon17.png')}"/>
                  </p>
                  <p>
                      Icône du bureau du logiciel Sky Eye Shield&nbsp;:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon18.png')}"/>
                  </p>
                  <p>
                      Interface du logiciel Sky Eye Shield&nbsp;:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon19.png')}"/>
                  </p>
                  <p>
                      Dans la liste des traders affichés par Tianyan Shield, si le statut est « en cours d&#39;exécution », cela signifie que le script Tianyan Shield du compte a été chargé normalement. Si le statut est « arrêté », cela signifie que le script Wikifxdefense Tianyan Shield du compte ne l&#39;est pas. actuellement chargé et doit être vérifié à temps et chargé correctement.
                  </p>
                  <p>
                      Actuellement, les comptes cTrader n&#39;apparaîtront pas dans la liste.
                  </p>
                  <p>
                      Si le Sky Eye Shield est chargé avec succès, l&#39;APP s&#39;affiche normalement mais l&#39;affichage de l&#39;interface s&#39;arrête, ce qui n&#39;affecte pas l&#39;utilisation normale. L&#39;affichage final sera soumis à l&#39;affichage de l&#39;APP.
                  </p>`,
        de: `
        <div class="title-box">Häufig gestellte Fragen</div>
                          <p class="bold">
                              1.Umgang mit häufigen Aktivierungsfehlern
                          </p>
                  <p>
                      1.1. MT4-Ladefehler:
                  </p>
                  <p>
                      DLL wird nicht überprüft
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon1.png')}"/>
                  </p>
                  <p>
                      Lösung: Klicken Sie über der Handelssoftware auf Extras-Optionen-EA Trading-DLL und aktivieren Sie das Kontrollkästchen, um das Sky Eye Shield-Skript neu zu laden.
                  </p>
                          <p class="bold">
                              2.Binden Sie andere Cloud-Hosts
                          </p>
                  <p>
                      Wie unten gezeigt bedeutet dies, dass das Konto an andere Cloud-Hosts gebunden ist und vor dem Abmelden mit einem neuen echten Konto oder an den Cloud-Host gebunden werden muss. (Die gebundene Cloud-Host-IP befindet sich im roten Feld)
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon2.png')}"/>
                  </p>
                          <p class="bold">
                              3.Das Handelskonto ist ein Demokonto
                          </p>
                  <p>
                      (1100010 Demokonto ist nicht verfügbar)
                  </p>
                  <p>
                      Wie unten gezeigt, bedeutet dies, dass eine Bindung mit einem echten Konto erforderlich ist und das Demokonto die Bindung nicht unterstützt.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon3.png')}"/>
                  </p>
                          <p class="bold">
                              4.Zu viele Transaktionen
                          </p>
                  <p>
                      Der Benutzer schränkt den Zeitbereich im Kontoverlauf auf diesen Monat oder diese Woche ein und aktiviert dann den Sky Eye Shield erneut.
                  </p>
                          <p class="bold">
                              5.Benutzerinformationen wurden nicht eingeholt
                          </p>
                  <p>
                      Wie unten gezeigt, bedeutet dies, dass die Benutzerinformationsdaten nicht in das Softwareverzeichnis importiert wurden.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon4.png')}"/>
                  </p>
                  <p>
                      Lösung: Wählen Sie im MT4-Terminal die Registerkarte „EA“ oder „Protokoll“, wählen Sie eine beliebige Zeile mit Protokollinhalten aus und klicken Sie zur Auswahl mit der rechten Maustaste
                  </p>
                  <p>
                      Öffnen Sie, wie in der Abbildung gezeigt:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon5.png')}"/>
                  </p>
                  <p>
                      Suchen Sie dann das entsprechende MQL4&#92;Files-Verzeichnis, wie zum Beispiel:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon6.png')}"/>
                  </p>
                  <p>
                      Überprüfen Sie nach dem Aufrufen des Verzeichnisses, ob es vorhanden ist
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon7.png')}"/>
                  </p>
                  <p>
                      Diese Datei. Wenn die Datei vorhanden ist, überprüfen Sie die Dateigröße. wie
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon8.png')}"/>
                  </p>
                  <p>
                      Wenn 0 KB angezeigt werden, weist dies auf eine Ausnahme hin. Normale Dateien können manuell importiert werden.
                  </p>
                  <p>
                      Importmethode: Öffnen Sie das Sky Eye Shield-Softwareverzeichnis, wählen Sie das Sky Eye Shield-Softwaresymbol auf dem Desktop aus, klicken Sie mit der rechten Maustaste und wählen Sie das aus
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon9.png')}"/>
                  </p>
                  <p>
                      Kopieren (überschreiben) Sie einfach die Datei in das oben stehende Verzeichnis. Nachdem der Import erfolgreich war, laden Sie das Sky Eye Shield-Skript neu.
                  </p>
                          <p class="bold">
                              6.Vorsichtsmaßnahmen
                          </p>
                  <p>
                      6.1. Der Cloud-Host muss alle Verlängerungsbedingungen erfüllen, bevor er normal genutzt werden kann, andernfalls wird er zurückgezogen. Neu erworbene Cloud-Hosts müssen die Verlängerungsbedingungen innerhalb von 7 Tagen erfüllen.
                  </p>
                  <p>
                      6.2. Die Verlängerungsbedingungen bestehen darin, ein echtes Handelskonto zu binden (der exklusive Cloud-Host muss an mindestens ein exklusives Händlerkonto gebunden sein) und einmal im Monat eine Transaktion auf dem Cloud-Host durchzuführen. Der 1-Yuan-Cloud-Host und der 45-Yuan-Cloud-Host können nur verlängert werden, wenn die Verlängerungsbedingungen erfüllt sind. Der kostenlose exklusive Cloud-Host wird automatisch kostenlos verlängert, wenn die Verlängerungsbedingungen erfüllt sind.
                  </p>
                  <p>
                      6.3. Anfragekanäle für Verlängerungsbedingungen
                  </p>
                  <p>
                      Öffnen Sie die Forex Sky Eye-App, klicken Sie auf „Ich“, „Mein VPS“ und dann zum Anzeigen auf „Jetzt verlängern“.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon10.png')}"/>
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon11.png')}"/>
                  </p>
                  <p>
                      <span>Wenn die Verlängerungsgebühr nicht beglichen wird, binden Sie bitte Ihr MT4/MT5-Handelskonto und schließen Sie eine Transaktion ab</span>
                  </p>
                          <p class="bold">
                              7.Eröffnen Sie weitere Konten
                          </p>
                  <p>
                      Klicken Sie mit der rechten Maustaste auf MT4 oder MT5 und öffnen Sie den Dateispeicherort
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon12.png')}"/>
                  </p>
                  <p>
                      Klicken Sie hier, um zum vorherigen Pfad zurückzukehren
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon13.png')}"/>
                  </p>
                  <p>
                      Kopieren Sie den gesamten MT4- oder MT5-Ordner auf den Desktop
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon14.png')}"/>
                  </p>
                  <p>
                      Datei auf dem Desktop öffnen
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon15.png')}"/>
                  </p>
                  <p>
                      Öffnen Sie den kopierten MT4-Ordner, erstellen Sie eine Anwendungsverknüpfung und senden Sie sie an den Desktop.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon16.png')}"/>
                  </p>
                  <p>
                      Sie können neue Handelssoftware über eine Verknüpfung auf dem Desktop öffnen, sich bei einem anderen Konto anmelden und mehrere Konten eröffnen.
                  </p>
                          <p class="bold">
                              8.Anweisungen zur Sky Eye Shield-Software
                          </p>
                  <p>
                      Einführung zum Sky Eye Shield:
                  </p>
                  <p>
                      Das weltweit erste und einzige High-Tech-Softwareprodukt, das Informationen zu Devisenhandelskonten in Echtzeit überwachen kann, sodass versteckte Kosten nirgends zu verbergen sind.
                  </p>
                  <p>
                      8.1. Stellen Sie die Verbindung zwischen VPS und APP her und Sie können Transaktionsinformationen in Echtzeit über die APP anzeigen.
                  </p>
                  <p>
                      8.2. Überwachen Sie Kontoinformationen in Echtzeit, um die Sicherheit Ihrer Transaktionen zu gewährleisten.
                  </p>
                  <p>
                      8.3. Nutzen Sie Big Data Mining und neuronale Netzwerktechnologie, um versteckte Transaktionskosten zu erkennen und die Handelsumgebung in Echtzeit zu diagnostizieren
                  </p>
                  <p>
                      Die Sky Eye Shield-Software startet zufällig und meldet sich automatisch an. Nach erfolgreicher Anmeldung ist sie in der Taskleiste in der unteren rechten Ecke des VPS zu sehen.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon17.png')}"/>
                  </p>
                  <p>
                      Desktop-Symbol der Sky Eye Shield-Software:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon18.png')}"/>
                  </p>
                  <p>
                      Sky Eye Shield-Softwareschnittstelle:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon19.png')}"/>
                  </p>
                  <p>
                      Wenn in der von Tianyan Shield angezeigten Liste der Händler der Status „läuft“ lautet, bedeutet dies, dass das Tianyan Shield-Skript des Kontos normal geladen wurde. Wenn der Status „gestoppt“ lautet, bedeutet dies, dass das Wikifxdefense Tianyan Shield-Skript des Kontos nicht geladen wird aktuell geladen und muss rechtzeitig überprüft und korrekt geladen werden.
                  </p>
                  <p>
                      Derzeit werden cTrader-Konten nicht in der Liste angezeigt.
                  </p>
                  <p>
                      Wenn das Sky Eye Shield erfolgreich geladen wurde, wird die APP normal angezeigt, aber die Anzeige der Benutzeroberfläche stoppt, was keinen Einfluss auf die normale Verwendung hat. Die endgültige Anzeige unterliegt der APP-Anzeige.
                  </p>`,
        pt: `
        <div class="title-box">perguntas frequentes</div>
                          <p class="bold">
                              1.Lidando com falhas comuns de ativação
                          </p>
                  <p>
                      1.1. Falha no carregamento do MT4:
                  </p>
                  <p>
                      DLL não está marcada
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon1.png')}"/>
                  </p>
                  <p>
                      1Solução: Clique em Ferramentas-Opções-EA Trading-DLL acima do software de negociação e marque para recarregar o script Sky Eye Shield.
                  </p>
                          <p class="bold">
                              2.Vincule outros hosts em nuvem
                          </p>
                  <p>
                      Conforme mostrado abaixo, isso significa que a conta está vinculada a outros hosts de nuvem e precisa ser vinculada a uma nova conta real ou vinculada ao host de nuvem antes de sair. (O IP do host da nuvem vinculado está na caixa vermelha)
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon2.png')}"/>
                  </p>
                          <p class="bold">
                              3.A conta de negociação é uma conta demo
                          </p>
                  <p>
                      (A conta de demonstração 1100010 não está disponível)
                  </p>
                  <p>
                      Conforme mostrado abaixo, isso significa que a vinculação com uma conta real é necessária e a conta demo não suporta vinculação.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon3.png')}"/>
                  </p>
                          <p class="bold">
                              4.Muitas transações
                          </p>
                  <p>
                      O usuário restringe o intervalo de tempo no histórico da conta para este mês ou esta semana e, em seguida, reativa o Sky Eye Shield.
                  </p>
                          <p class="bold">
                              5.Informações do usuário não obtidas
                          </p>
                  <p>
                      Conforme mostrado abaixo, significa que os dados de informações do usuário não foram importados para o diretório do software.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon4.png')}"/>
                  </p>
                  <p>
                      Solução: No terminal MT4, selecione a página da guia EA ou Log, selecione qualquer linha de conteúdo de log e clique com o botão direito para selecionar
                  </p>
                  <p>
                      Abra, conforme mostrado na figura:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon5.png')}"/>
                  </p>
                  <p>
                      Em seguida, encontre o diretório MQL4&#92;Files correspondente, como:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon6.png')}"/>
                  </p>
                  <p>
                      Depois de entrar no diretório, verifique se há
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon7.png')}"/>
                  </p>
                  <p>
                      este ficheiro. Se o arquivo existir, verifique o tamanho do arquivo. como
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon8.png')}"/>
                  </p>
                  <p>
                      Se exibir 0Kb, indica uma exceção. Arquivos normais podem ser importados manualmente.
                  </p>
                  <p>
                      Método de importação: Abra o diretório do software Sky Eye Shield, selecione o ícone do software Sky Eye Shield na área de trabalho, clique com o botão direito e selecione o
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon9.png')}"/>
                  </p>
                  <p>
                      Basta copiar (sobrescrever) o arquivo para o diretório acima. Após a importação ser bem-sucedida, recarregue o script Sky Eye Shield.
                  </p>
                          <p class="bold">
                              6.Precauções
                          </p>
                  <p>
                      6.1 O host em nuvem deve atender a todas as condições de renovação antes de poder ser usado normalmente, caso contrário será retirado. Os hosts em nuvem recém-adquiridos devem atender às condições de renovação em até sete dias.
                  </p>
                  <p>
                      6.2 As condições de renovação são vincular uma conta de negociação real (o host exclusivo na nuvem deve estar vinculado a pelo menos uma conta exclusiva do trader) e realizar uma transação no host na nuvem uma vez por mês. O host em nuvem de 1 yuan e o host em nuvem de 45 yuans podem ser renovados somente se as condições de renovação forem atendidas. O host em nuvem exclusivo gratuito será automaticamente renovado gratuitamente quando as condições de renovação forem atendidas.
                  </p>
                  <p>
                      6.3 Canais de consulta sobre condições de renovação
                  </p>
                  <p>
                      Abra o APP Forex Sky Eye, clique em &quot;Eu&quot;, &quot;Meu VPS&quot; e clique em &quot;Renovar agora&quot; para visualizar.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon10.png')}"/>
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon11.png')}"/>
                  </p>
                  <p>
                      <span>Se a taxa de renovação não for satisfeita, vincule sua conta de negociação MT4/MT5 e conclua uma transação</span>
                  </p>
                          <p class="bold">
                              7.Abra mais contas
                          </p>
                  <p>
                      Clique com o botão direito em MT4 ou MT5 e abra o local do arquivo
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon12.png')}"/>
                  </p>
                  <p>
                      Clique aqui para retornar ao caminho anterior
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon13.png')}"/>
                  </p>
                  <p>
                      Copie toda a pasta MT4 ou MT5 para a área de trabalho
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon14.png')}"/>
                  </p>
                  <p>
                      Abrir arquivo na área de trabalho
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon15.png')}"/>
                  </p>
                  <p>
                      Abra a pasta MT4 copiada, crie um atalho de aplicativo e envie-o para a área de trabalho.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon16.png')}"/>
                  </p>
                  <p>
                      Você pode abrir um novo software de negociação por meio de um atalho na área de trabalho, fazer login em outra conta e abrir várias contas.
                  </p>
                          <p class="bold">
                              8.Instruções do software Sky Eye Shield
                          </p>
                  <p>
                      Introdução ao Escudo Sky Eye:
                  </p>
                  <p>
                      O primeiro e único produto de software de alta tecnologia do mundo que pode monitorar as informações da conta de negociação cambial em tempo real, fazendo com que os custos ocultos não tenham onde se esconder.
                  </p>
                  <p>
                      8.1 Realize a interligação entre VPS e APP, podendo visualizar as informações das transações em tempo real através do APP.
                  </p>
                  <p>
                      8.2. Monitore as informações da conta em tempo real para garantir a segurança de suas transações.
                  </p>
                  <p>
                      8.3. Usar mineração de big data e tecnologia de rede neural para detectar custos de transação ocultos e diagnosticar o ambiente comercial em tempo real
                  </p>
                  <p>
                      O software Sky Eye Shield inicia aleatoriamente e faz login automaticamente. Após o login bem-sucedido, ele pode ser visto na bandeja do sistema no canto inferior direito do VPS.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon17.png')}"/>
                  </p>
                  <p>
                      Ícone da área de trabalho do software Sky Eye Shield:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon18.png')}"/>
                  </p>
                  <p>
                      Interface do software Sky Eye Shield:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon19.png')}"/>
                  </p>
                  <p>
                      Na lista de traders exibida pelo Tianyan Shield, se o status for &quot;running&quot;, significa que o script Tianyan Shield da conta foi carregado normalmente. Se o status for &quot;stopped&quot;, significa que o script Wikifxdefense Tianyan Shield da conta não está. atualmente carregado e precisa ser verificado a tempo e carregado corretamente.
                  </p>
                  <p>
                      Atualmente as contas cTrader não aparecerão na lista.
                  </p>
                  <p>
                      Se o Sky Eye Shield for carregado com sucesso, o APP será exibido normalmente, mas a exibição da interface parará, o que não afetará o uso normal.
                  </p>`,
        tr: `
        <div class="title-box">Sıkça Sorulan Sorular</div>
                          <p class="bold">
                              1.Yaygın etkinleştirme hatalarını ele alma
                          </p>
                  <p>
                      1.1 MT4 yükleme hatası:
                  </p>
                  <p>
                      DLL kontrol edilmiyor
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon1.png')}"/>
                  </p>
                  <p>
                      Çözüm: Ticaret yazılımının üzerindeki Araçlar-Seçenekler-EA Ticaret-DLL&#39;ye tıklayın ve Sky Eye Shield komut dosyasını yeniden yüklemek için işaretleyin.
                  </p>
                          <p class="bold">
                              2.Diğer bulut ana bilgisayarlarını bağlayın
                          </p>
                  <p>
                      Aşağıda gösterildiği gibi bu, hesabın diğer bulut ana bilgisayarlarına bağlı olduğu ve çıkış yapmadan önce yeni bir gerçek hesaba bağlanması veya bulut ana bilgisayarına bağlanması gerektiği anlamına gelir. (Bağlı bulut ana bilgisayar IP&#39;si kırmızı kutudadır)
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon2.png')}"/>
                  </p>
                          <p class="bold">
                              3.Ticaret hesabı bir demo hesabıdır
                          </p>
                  <p>
                      (1100010 Demo Hesabı mevcut değil)
                  </p>
                  <p>
                      Aşağıda gösterildiği gibi, gerçek hesapla bağlanmanın gerekli olduğu ve demo hesabının bağlamayı desteklemediği anlamına gelir.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon3.png')}"/>
                  </p>
                          <p class="bold">
                              4.Çok fazla işlem
                          </p>
                  <p>
                      Kullanıcı, hesap geçmişindeki zaman aralığını bu aya veya bu haftaya daraltır ve ardından Sky Eye Shield&#39;i yeniden etkinleştirir.
                  </p>
                          <p class="bold">
                              5.Kullanıcı bilgileri alınamıyor
                          </p>
                  <p>
                      Aşağıda gösterildiği gibi kullanıcı bilgi verilerinin yazılım dizinine aktarılmadığı anlamına gelir.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon4.png')}"/>
                  </p>
                  <p>
                      Çözüm: MT4 terminalinde EA veya Günlük sekme sayfasını seçin, günlük içeriğinin herhangi bir satırını seçin ve seçmek için sağ tıklayın.
                  </p>
                  <p>
                      Şekilde gösterildiği gibi açın:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon5.png')}"/>
                  </p>
                  <p>
                      Daha sonra karşılık gelen MQL4&#92;Files dizinini bulun:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon6.png')}"/>
                  </p>
                  <p>
                      Dizine girdikten sonra, olup olmadığını kontrol edin.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon7.png')}"/>
                  </p>
                  <p>
                      bu dosya. Dosya mevcutsa dosya boyutunu kontrol edin. beğenmek
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon8.png')}"/>
                  </p>
                  <p>
                      0Kb görüntüleniyorsa bu bir istisna olduğunu gösterir. Normal dosyalar manuel olarak içe aktarılabilir.
                  </p>
                  <p>
                      İçe aktarma yöntemi: Sky Eye Shield yazılım dizinini açın, masaüstündeki Sky Eye Shield yazılım simgesini seçin, sağ tıklayın ve
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon9.png')}"/>
                  </p>
                  <p>
                      Dosyayı yukarıdaki dizine kopyalamanız (üzerine yazmanız) yeterlidir. İçe aktarma başarılı olduktan sonra Sky Eye Shield komut dosyasını yeniden yükleyin.
                  </p>
                          <p class="bold">
                             6.Önlemler
                          </p>
                  <p>
                      6.1 Bulut ana bilgisayarının normal şekilde kullanılabilmesi için tüm yenileme koşullarını karşılaması gerekir, aksi takdirde geri çekilecektir. Yeni satın alınan bulut ana bilgisayarların 7 gün içinde yenileme koşullarını karşılaması gerekir.
                  </p>
                  <p>
                      6.2 Yenileme koşulları, gerçek bir ticaret hesabını bağlamak (özel bulut sunucusunun en az bir özel yatırımcı hesabına bağlı olması gerekir) ve bulut sunucusunda ayda bir işlem gerçekleştirmektir. 1 yuan tutarındaki bulut ana bilgisayarı ve 45 yuan tutarındaki bulut sunucusu, yalnızca yenileme koşulları karşılandığı takdirde yenilenebilir. Ücretsiz özel bulut sunucusu, yenileme koşulları karşılandığında otomatik olarak ücretsiz olarak yenilenecektir.
                  </p>
                  <p>
                      6.3 Yenileme koşulları için sorgulama kanalları
                  </p>
                  <p>
                      Forex Sky Eye Uygulamasını açın, &quot;Ben&quot;, &quot;VPS&#39;im&quot; seçeneğine tıklayın ve ardından görüntülemek için &quot;Şimdi Yenile&quot; seçeneğine tıklayın.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon10.png')}"/>
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon11.png')}"/>
                  </p>
                  <p>
                      <span>Yenileme ücreti karşılanmazsa lütfen MT4/MT5 yatırım hesabınızı bağlayın ve işlemi tamamlayın</span>
                  </p>
                          <p class="bold">
                              7.Daha fazla hesap açın
                          </p>
                  <p>
                      MT4 veya MT5&#39;e sağ tıklayın ve dosya konumunu açın
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon12.png')}"/>
                  </p>
                  <p>
                      Önceki yola dönmek için burayı tıklayın
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon13.png')}"/>
                  </p>
                  <p>
                      MT4 veya MT5 klasörünün tamamını masaüstüne kopyalayın
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon14.png')}"/>
                  </p>
                  <p>
                      Dosyayı masaüstünde aç
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon15.png')}"/>
                  </p>
                  <p>
                      Kopyalanan MT4 klasörünü açın, bir uygulama kısayolu oluşturun ve bunu masaüstüne gönderin.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon16.png')}"/>
                  </p>
                  <p>
                      Masaüstündeki bir kısayol aracılığıyla yeni ticaret yazılımı açabilir, başka bir hesapta oturum açabilir ve birden fazla hesap açabilirsiniz.
                  </p>
                          <p class="bold">
                              8.Sky Eye Shield Yazılım Talimatları
                          </p>
                  <p>
                      Gökyüzü Göz Kalkanına Giriş:
                  </p>
                  <p>
                      Döviz alım satım hesap bilgilerini gerçek zamanlı olarak izleyebilen ve gizli maliyetleri saklanacak yer olmayan dünyanın ilk ve tek yüksek teknolojili yazılım ürünü.
                  </p>
                  <p>
                      8.1. VPS ile APP arasındaki bağlantıyı gerçekleştirin ve işlem bilgilerini APP aracılığıyla gerçek zamanlı olarak görüntüleyebilirsiniz.
                  </p>
                  <p>
                      8.2. İşlemlerinizin güvenliğini sağlamak için hesap bilgilerini gerçek zamanlı olarak izleyin.
                  </p>
                  <p>
                      8.3. Gizli işlem maliyetlerini tespit etmek ve ticaret ortamını gerçek zamanlı olarak teşhis etmek için büyük veri madenciliği ve sinir ağı teknolojisini kullanın.
                  </p>
                  <p>
                      Sky Eye Shield yazılımı rastgele başlar ve başarılı bir giriş yaptıktan sonra, VPS&#39;nin sağ alt köşesindeki sistem tepsisinde görülebilir.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon17.png')}"/>
                  </p>
                  <p>
                      Sky Eye Shield yazılımı masaüstü simgesi:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon18.png')}"/>
                  </p>
                  <p>
                      Sky Eye Shield yazılım arayüzü:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon19.png')}"/>
                  </p>
                  <p>
                      Tianyan Shield tarafından görüntülenen yatırımcılar listesinde, eğer durum &quot;çalışıyor&quot; ise bu, hesabın Tianyan Shield scriptinin normal şekilde yüklendiği anlamına gelir. Eğer durum &quot;durduruldu&quot; ise bu, hesabın Wikifxdefense Tianyan Shield scriptinin olmadığı anlamına gelir. şu anda yüklü ve zamanında kontrol edilmesi ve doğru şekilde yüklenmesi gerekiyor.
                  </p>
                  <p>
                      Şu anda cTrader hesapları listede görünmeyecek.
                  </p>
                  <p>
                      Sky Eye Shield başarılı bir şekilde yüklenirse, APP normal şekilde görüntülenir ancak arayüz ekranı durur, bu da normal kullanımı etkilemez. Son ekran, APP ekranına tabi olacaktır.
                  </p>`,
        ko: `
        <div class="title-box">자주 묻는 질문</div>
                          <p class="bold">
                              1.일반적인 활성화 실패 처리
                          </p>
                  <p>
                      1.1. MT4 로딩 실패:
                  </p>
                  <p>
                      DLL이 확인되지 않았습니다.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon1.png')}"/>
                  </p>
                  <p>
                      해결 방법: 거래 소프트웨어 위에 있는 도구-옵션-EA Trading-DLL을 클릭하고 Sky Eye Shield 스크립트를 다시 로드하는지 확인하세요.
                  </p>
                          <p class="bold">
                              2.다른 클라우드 호스트 바인딩
                          </p>
                  <p>
                      아래와 같이 해당 계정이 다른 클라우드 호스트에 바인딩되어 있다는 의미이며, 로그아웃하기 전에 새로운 실제 계정으로 바인딩하거나 클라우드 호스트에 바인딩해야 합니다. (바인딩된 클라우드 호스트 IP는 빨간색 상자 안에 있습니다)
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon2.png')}"/>
                  </p>
                          <p class="bold">
                              3.거래 계좌는 데모 계좌입니다.
                          </p>
                  <p>
                      (1100010 데모 계정을 사용할 수 없습니다)
                  </p>
                  <p>
                      아래와 같이 실계좌와의 바인딩이 필요하다는 뜻이며, 데모계좌는 바인딩을 지원하지 않습니다.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon3.png')}"/>
                  </p>
                          <p class="bold">
                              4.거래가 너무 많다
                          </p>
                  <p>
                      사용자는 계정 기록에서 기간을 이번 달 또는 이번 주로 좁힌 다음 Sky Eye Shield를 다시 활성화합니다.
                  </p>
                          <p class="bold">
                              5.이용자 정보를 취득하지 않은 경우
                          </p>
                  <p>
                      아래와 같이 사용자 정보 데이터를 소프트웨어 디렉터리로 가져오지 않았음을 의미합니다.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon4.png')}"/>
                  </p>
                  <p>
                      해결 방법: MT4 터미널에서 EA 또는 로그 탭 페이지를 선택하고 로그 내용 줄을 선택한 다음 마우스 오른쪽 버튼을 클릭하여 선택합니다.
                  </p>
                  <p>
                      그림과 같이 엽니다.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon5.png')}"/>
                  </p>
                  <p>
                      그런 다음 다음과 같이 해당 MQL4&#92;Files 디렉터리를 찾으세요.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon6.png')}"/>
                  </p>
                  <p>
                      디렉토리를 입력한 후 해당 디렉토리가 있는지 확인하세요.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon7.png')}"/>
                  </p>
                  <p>
                      이 파일. 파일이 존재하는 경우 파일 크기를 확인하십시오. 좋다
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon8.png')}"/>
                  </p>
                  <p>
                      0Kb가 표시되면 예외가 발생한 것입니다. 일반 파일은 수동으로 가져올 수 있습니다.
                  </p>
                  <p>
                      가져오기 방법: Sky Eye Shield 소프트웨어 디렉터리를 열고 바탕 화면에서 Sky Eye Shield 소프트웨어 아이콘을 선택한 후 마우스 오른쪽 버튼을 클릭하고
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon9.png')}"/>
                  </p>
                  <p>
                      파일을 위의 디렉터리에 복사(덮어쓰기)하면 됩니다. 가져오기가 성공한 후 Sky Eye Shield 스크립트를 다시 로드합니다.
                  </p>
                          <p class="bold">
                              6.주의사항
                          </p>
                  <p>
                      6.1. 클라우드 호스트는 모든 갱신 조건을 충족해야 정상적으로 사용할 수 있으며, 그렇지 않으면 철회됩니다. 새로 구매한 클라우드 호스트는 7일 이내에 갱신 조건을 충족해야 합니다.
                  </p>
                  <p>
                      6.2.갱신 조건은 실제 거래 계좌를 바인딩하고(전용 클라우드 호스트는 최소 하나의 전용 트레이더 계정에 바인딩해야 함) 클라우드 호스트에서 월 1회 거래를 수행하는 것입니다. 1위안 클라우드 호스트와 45위안 클라우드 호스트는 갱신 조건이 충족되어야만 갱신할 수 있습니다. 무료 전용 클라우드 호스트는 갱신 조건이 충족되면 자동으로 무료로 갱신됩니다.
                  </p>
                  <p>
                      6.3.갱신조건 문의채널
                  </p>
                  <p>
                      Forex Sky Eye 앱을 열고 &quot;나&quot;, &quot;내 VPS&quot;를 클릭한 다음 &quot;지금 갱신&quot;을 클릭하여 확인하세요.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon10.png')}"/>
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon11.png')}"/>
                  </p>
                  <p>
                      <span>갱신 수수료가 충족되지 않으면 MT4/MT5 거래 계좌를 연결하고 거래를 완료하세요.</span>
                  </p>
                          <p class="bold">
                              7.더 많은 계좌 개설
                          </p>
                  <p>
                      MT4 또는 MT5를 마우스 오른쪽 버튼으로 클릭하고 파일 위치를 엽니다.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon12.png')}"/>
                  </p>
                  <p>
                      이전 경로로 돌아가려면 여기를 클릭하세요.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon13.png')}"/>
                  </p>
                  <p>
                      MT4 또는 MT5 폴더 전체를 데스크탑에 복사하세요.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon14.png')}"/>
                  </p>
                  <p>
                      데스크탑에서 파일 열기
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon15.png')}"/>
                  </p>
                  <p>
                      복사된 MT4 폴더를 열고, 애플리케이션 바로가기를 생성하여 바탕화면으로 보냅니다.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon16.png')}"/>
                  </p>
                  <p>
                      데스크탑의 바로가기를 통해 새로운 거래 소프트웨어를 열고, 다른 계좌에 로그인하고, 여러 계좌를 개설할 수 있습니다.
                  </p>
                          <p class="bold">
                              8.Sky Eye Shield 소프트웨어 지침
                          </p>
                  <p>
                      스카이 아이 쉴드 소개:
                  </p>
                  <p>
                      외환거래계좌정보를 실시간으로 모니터링하여 숨겨진 비용을 숨길 수 없는 세계 최초이자 유일한 첨단 소프트웨어 제품입니다.
                  </p>
                  <p>
                      8.1. VPS와 APP의 상호 연결을 실현하고, APP를 통해 거래 정보를 실시간으로 확인할 수 있습니다.
                  </p>
                  <p>
                      8.2. 거래의 안전을 보장하기 위해 실시간으로 계정 정보를 모니터링합니다.
                  </p>
                  <p>
                      8.3. 빅데이터 마이닝 및 신경망 기술을 활용하여 숨겨진 거래 비용을 탐지하고 거래 환경을 실시간으로 진단합니다.
                  </p>
                  <p>
                      Sky Eye Shield 소프트웨어는 무작위로 시작되어 자동으로 로그인됩니다. 로그인에 성공하면 VPS 오른쪽 하단에 있는 시스템 트레이에서 볼 수 있습니다.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon17.png')}"/>
                  </p>
                  <p>
                      Sky Eye Shield 소프트웨어 바탕화면 아이콘:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon18.png')}"/>
                  </p>
                  <p>
                      Sky Eye Shield 소프트웨어 인터페이스:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon19.png')}"/>
                  </p>
                  <p>
                      Tianyan Shield가 표시하는 거래자 목록에서 상태가 &quot;실행 중&quot;이면 해당 계정의 Tianyan Shield 스크립트가 정상적으로 로드되었음을 의미합니다. 상태가 &quot;중지됨&quot;이면 해당 계정의 Wikifxdefense Tianyan Shield 스크립트가 로드되지 않았음을 의미합니다. 현재 로드되어 있으며 적시에 확인하고 올바르게 로드해야 합니다.
                  </p>
                  <p>
                      현재 cTrader 계정은 목록에 표시되지 않습니다.
                  </p>
                  <p>
                      Sky Eye Shield가 성공적으로 로드되면 앱은 정상적으로 표시되지만 인터페이스 표시는 중지되며 이는 정상적인 사용에 영향을 미치지 않습니다.
                  </p>`,
        ar: `
        <div class="title-box">أسئلة مكررة</div>
                          <p class="bold">
                              1.التعامل مع حالات فشل التنشيط الشائعة
                          </p>
                  <p>
                      1.1 فشل تحميل MT4:
                  </p>
                  <p>
                      لم يتم تحديد DLL
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon1.png')}"/>
                  </p>
                  <p>
                      الحل: انقر فوق Tools-Options-EA Trading-DLL أعلى برنامج التداول وتحقق من إعادة تحميل البرنامج النصي Sky Eye Shield.
                  </p>
                          <p class="bold">
                              2.ربط المضيفين السحابيين الآخرين
                          </p>
                  <p>
                      كما هو موضح أدناه، فهذا يعني أن الحساب مرتبط بمضيفي السحابة الآخرين ويجب أن يكون مرتبطًا بحساب حقيقي جديد أو مرتبط بمضيف السحابة قبل تسجيل الخروج. (عنوان IP الخاص بالمضيف السحابي المنضم موجود في المربع الأحمر)
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon2.png')}"/>
                  </p>
                          <p class="bold">
                              3.حساب التداول هو حساب تجريبي
                          </p>
                  <p>
                      (1100010 الحساب التجريبي غير متوفر)
                  </p>
                  <p>
                      كما هو موضح أدناه، فهذا يعني أن الارتباط بالحساب الحقيقي مطلوب، والحساب التجريبي لا يدعم الربط.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon3.png')}"/>
                  </p>
                          <p class="bold">
                              4.عدد كبير جدًا من المعاملات
                          </p>
                  <p>
                      يقوم المستخدم بتضييق النطاق الزمني في سجل الحساب إلى هذا الشهر أو هذا الأسبوع، ثم يقوم بإعادة تنشيط Sky Eye Shield.
                  </p>
                          <p class="bold">
                              5.لم يتم الحصول على معلومات المستخدم
                          </p>
                  <p>
                      كما هو موضح أدناه، فهذا يعني أنه لم يتم استيراد بيانات معلومات المستخدم إلى دليل البرنامج.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon4.png')}"/>
                  </p>
                  <p>
                      الحل: في محطة MT4، حدد صفحة علامة التبويب EA أو السجل، وحدد أي سطر من محتوى السجل، ثم انقر بزر الماوس الأيمن لتحديد
                  </p>
                  <p>
                      افتح كما هو موضح في الشكل:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon5.png')}"/>
                  </p>
                  <p>
                      ثم ابحث عن دليل MQL4&#92;Files المقابل، مثل:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon6.png')}"/>
                  </p>
                  <p>
                      بعد الدخول إلى الدليل، تحقق مما إذا كان هناك
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon7.png')}"/>
                  </p>
                  <p>
                      هذا الملف. إذا كان الملف موجودًا، فتحقق من حجم الملف. يحب
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon8.png')}"/>
                  </p>
                  <p>
                      إذا عرض 0 كيلو بايت، فهذا يشير إلى استثناء. يمكن استيراد الملفات العادية يدويًا.
                  </p>
                  <p>
                      طريقة الاستيراد: افتح دليل برنامج Sky Eye Shield، وحدد أيقونة برنامج Sky Eye Shield على سطح المكتب، ثم انقر بزر الماوس الأيمن وحدد
                  </p>
                  <p>
                      [
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon9.png')}"/>
                  </p>
                  <p>
                      ما عليك سوى نسخ (الكتابة فوق) الملف إلى الدليل أعلاه. بعد نجاح الاستيراد، قم بإعادة تحميل البرنامج النصي Sky Eye Shield.
                  </p>
                          <p class="bold">
                              6.الاحتياطات
                          </p>
                  <p>
                      6.1 يجب أن يستوفي المضيف السحابي جميع شروط التجديد قبل أن يتم استخدامه بشكل طبيعي، وإلا سيتم سحبه. يجب أن يستوفي مضيفو السحابة الذين تم شراؤهم حديثًا شروط التجديد خلال 7 أيام.
                  </p>
                  <p>
                      6.2 شروط التجديد هي ربط حساب تداول حقيقي (يجب أن يكون المضيف السحابي الحصري مرتبطًا بحساب متداول حصري واحد على الأقل) وإجراء معاملة على المضيف السحابي مرة واحدة شهريًا. لا يمكن تجديد المضيف السحابي بقيمة 1 يوان والمضيف السحابي بقيمة 45 يوان إلا في حالة استيفاء شروط التجديد. سيتم تجديد المضيف السحابي الحصري المجاني تلقائيًا عند استيفاء شروط التجديد.
                  </p>
                  <p>
                      6.3 قنوات الاستعلام عن شروط التجديد
                  </p>
                  <p>
                      افتح تطبيق Forex Sky Eye، وانقر فوق &quot;Me&quot;، و&quot;My VPS&quot;، ثم انقر فوق &quot;Renew Now&quot; للعرض.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon10.png')}"/>
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon11.png')}"/>
                  </p>
                  <p>
                    <span>
                      إذا لم يتم استيفاء رسوم التجديد، فيرجى ربط حساب التداول MT4/MT5 الخاص بك وإكمال المعاملة
                    </span>
                  </p>
                          <p class="bold">
                              7.افتح المزيد من الحسابات
                          </p>
                  <p>
                      انقر بزر الماوس الأيمن على MT4 أو MT5 وافتح موقع الملف
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon12.png')}"/>
                  </p>
                  <p>
                      انقر هنا للعودة إلى المسار السابق
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon13.png')}"/>
                  </p>
                  <p>
                      انسخ مجلد MT4 أو MT5 بالكامل إلى سطح المكتب
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon14.png')}"/>
                  </p>
                  <p>
                      فتح الملف على سطح المكتب
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon15.png')}"/>
                  </p>
                  <p>
                      افتح مجلد MT4 المنسوخ، وقم بإنشاء اختصار للتطبيق، وأرسله إلى سطح المكتب.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon16.png')}"/>
                  </p>
                  <p>
                      يمكنك فتح برنامج تداول جديد من خلال اختصار على سطح المكتب، وتسجيل الدخول إلى حساب آخر، وفتح حسابات متعددة.
                  </p>
                          <p class="bold">
                              8.تعليمات برنامج Sky Eye Shield
                          </p>
                  <p>
                      مقدمة إلى Sky Eye Shield:
                  </p>
                  <p>
                      منتج البرمجيات الأول والوحيد عالي التقنية في العالم الذي يمكنه مراقبة معلومات حساب تداول العملات الأجنبية في الوقت الفعلي، مما يجعل التكاليف الخفية لا يمكن إخفاءها.
                  </p>
                  <p>
                      8.1. تحقيق الاتصال البيني بين VPS وAPP، ويمكنك عرض معلومات المعاملة في الوقت الفعلي من خلال التطبيق.
                  </p>
                  <p>
                      8.2 مراقبة معلومات الحساب في الوقت الفعلي لضمان سلامة معاملاتك.
                  </p>
                  <p>
                      8.3. استخدم تقنية التنقيب عن البيانات الضخمة وتكنولوجيا الشبكات العصبية لاكتشاف تكاليف المعاملات المخفية وتشخيص بيئة التداول في الوقت الفعلي
                  </p>
                  <p>
                      يبدأ برنامج Sky Eye Shield بشكل عشوائي ويتم تسجيل الدخول تلقائيًا بعد تسجيل الدخول بنجاح، ويمكن رؤيته في علبة النظام في الركن الأيمن السفلي من VPS.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon17.png')}"/>
                  </p>
                  <p>
                      رمز سطح المكتب لبرنامج Sky Eye Shield:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon18.png')}"/>
                  </p>
                  <p>
                      واجهة برنامج Sky Eye Shield:
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/issue-icon19.png')}"/>
                  </p>
                  <p>
                      في قائمة المتداولين التي تعرضها Tianyan Shield، إذا كانت الحالة &quot;قيد التشغيل&quot;، فهذا يعني أن البرنامج النصي للحساب Tianyan Shield قد تم تحميله بشكل طبيعي إذا كانت الحالة &quot;متوقفة&quot;، فهذا يعني أن البرنامج النصي الخاص بـ Wikifxdefense Tianyan Shield ليس كذلك تم تحميله حاليًا ويجب التحقق منه في الوقت المناسب وتحميله بشكل صحيح.
                  </p>
                  <p>
                      لن تظهر حسابات cTrader حاليًا في القائمة.
                  </p>
                  <p>
                      إذا تم تحميل Sky Eye Shield بنجاح، فسيتم عرض التطبيق بشكل طبيعي ولكن يتوقف عرض الواجهة، مما لا يؤثر على الاستخدام العادي، ويجب أن تخضع الشاشة النهائية لعرض التطبيق.
                  </p>`
      }
    }
  },
  head () {
    return {
      title: this.$t('22981'),
      meta: [
        { name: 'Description', content: this.$t('22982') }
      ]
    }
  }
}
